var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 700 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:none;}.cls-131,.cls-167,.cls-21,.cls-23,.cls-25,.cls-29,.cls-3,.cls-4,.cls-7{opacity:0.5;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:#00c7e5;}.cls-10,.cls-11,.cls-13,.cls-133,.cls-14,.cls-15,.cls-166,.cls-169,.cls-170,.cls-171,.cls-196,.cls-208,.cls-209,.cls-6,.cls-8,.cls-9{mix-blend-mode:multiply;}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-10);}.cls-14{fill:url(#linear-gradient-11);}.cls-15{fill:url(#linear-gradient-12);}.cls-16{fill:url(#linear-gradient-13);}.cls-17{fill:url(#linear-gradient-14);}.cls-18{fill:url(#linear-gradient-15);}.cls-19{fill:url(#linear-gradient-16);}.cls-20{fill:url(#linear-gradient-17);}.cls-21{fill:url(#linear-gradient-18);}.cls-22{fill:url(#linear-gradient-19);}.cls-23{fill:url(#linear-gradient-20);}.cls-24{fill:url(#linear-gradient-21);}.cls-25{fill:url(#linear-gradient-22);}.cls-26{opacity:0.43;fill:url(#linear-gradient-23);}.cls-27{fill:url(#linear-gradient-24);}.cls-28{fill:url(#linear-gradient-25);}.cls-29{fill:url(#linear-gradient-26);}.cls-30{fill:url(#linear-gradient-28);}.cls-222,.cls-31{fill:#79e2f2;}.cls-32{fill:url(#linear-gradient-29);}.cls-33{fill:url(#linear-gradient-30);}.cls-34{fill:url(#linear-gradient-31);}.cls-35{fill:url(#linear-gradient-32);}.cls-36{fill:#2684ff;}.cls-37{fill:url(#linear-gradient-33);}.cls-38{fill:url(#linear-gradient-35);}.cls-39{fill:url(#linear-gradient-41);}.cls-40{fill:url(#linear-gradient-42);}.cls-41{fill:url(#linear-gradient-44);}.cls-42{fill:url(#linear-gradient-45);}.cls-43{fill:url(#linear-gradient-53);}.cls-44{fill:url(#linear-gradient-58);}.cls-45{fill:url(#linear-gradient-59);}.cls-46{fill:url(#linear-gradient-61);}.cls-47{fill:url(#linear-gradient-62);}.cls-48{fill:url(#linear-gradient-63);}.cls-49{fill:url(#linear-gradient-64);}.cls-50{fill:url(#linear-gradient-65);}.cls-51{fill:url(#linear-gradient-66);}.cls-52{fill:url(#linear-gradient-67);}.cls-53{fill:url(#linear-gradient-68);}.cls-54{fill:url(#linear-gradient-69);}.cls-55{fill:url(#linear-gradient-70);}.cls-56{fill:url(#linear-gradient-71);}.cls-57{fill:url(#linear-gradient-72);}.cls-58{fill:url(#linear-gradient-73);}.cls-59{fill:url(#linear-gradient-74);}.cls-60{fill:url(#linear-gradient-75);}.cls-61{fill:url(#linear-gradient-76);}.cls-62{fill:url(#linear-gradient-77);}.cls-63{fill:url(#linear-gradient-78);}.cls-64{fill:url(#linear-gradient-79);}.cls-65{fill:url(#linear-gradient-80);}.cls-66{fill:url(#linear-gradient-81);}.cls-67{fill:url(#linear-gradient-82);}.cls-68{fill:url(#linear-gradient-83);}.cls-69{fill:url(#linear-gradient-84);}.cls-70{fill:url(#linear-gradient-85);}.cls-71{fill:url(#linear-gradient-86);}.cls-72{fill:url(#linear-gradient-87);}.cls-73{fill:url(#linear-gradient-88);}.cls-74{fill:url(#linear-gradient-89);}.cls-75{fill:url(#linear-gradient-90);}.cls-76{fill:url(#linear-gradient-91);}.cls-77{fill:url(#linear-gradient-92);}.cls-78{fill:url(#linear-gradient-93);}.cls-79{fill:url(#linear-gradient-94);}.cls-80{fill:url(#linear-gradient-95);}.cls-81{fill:url(#linear-gradient-96);}.cls-82{fill:url(#linear-gradient-97);}.cls-83{fill:url(#linear-gradient-98);}.cls-84{fill:#e5e8ec;}.cls-85{fill:#f7f8f9;}.cls-86{fill:#ffab00;}.cls-87{fill:#cfd4db;}.cls-88{fill:#3dc7dc;}.cls-89{fill:url(#linear-gradient-99);}.cls-90{fill:url(#linear-gradient-100);}.cls-91{fill:url(#linear-gradient-101);}.cls-92{fill:url(#linear-gradient-102);}.cls-93{fill:url(#linear-gradient-103);}.cls-94{fill:url(#linear-gradient-104);}.cls-220,.cls-95{fill:#0065ff;}.cls-96{fill:url(#linear-gradient-105);}.cls-97{fill:url(#linear-gradient-106);}.cls-98{fill:url(#linear-gradient-107);}.cls-99{fill:url(#linear-gradient-108);}.cls-100{fill:url(#linear-gradient-109);}.cls-101{fill:url(#linear-gradient-110);}.cls-102{fill:url(#linear-gradient-111);}.cls-103{fill:url(#linear-gradient-112);}.cls-104{fill:url(#linear-gradient-113);}.cls-105{fill:url(#linear-gradient-114);}.cls-106{fill:url(#linear-gradient-115);}.cls-107{fill:url(#linear-gradient-116);}.cls-108{fill:url(#linear-gradient-117);}.cls-109{fill:url(#linear-gradient-118);}.cls-110{fill:url(#linear-gradient-119);}.cls-111{fill:url(#linear-gradient-120);}.cls-112{fill:url(#linear-gradient-121);}.cls-113{fill:url(#linear-gradient-122);}.cls-114{fill:url(#linear-gradient-123);}.cls-115{fill:url(#linear-gradient-124);}.cls-116{fill:url(#linear-gradient-125);}.cls-117{fill:url(#linear-gradient-126);}.cls-118{fill:url(#linear-gradient-127);}.cls-119{fill:url(#linear-gradient-128);}.cls-120{fill:url(#linear-gradient-129);}.cls-121{fill:url(#linear-gradient-130);}.cls-122{fill:url(#linear-gradient-131);}.cls-123{fill:url(#linear-gradient-132);}.cls-124{fill:url(#linear-gradient-133);}.cls-125{fill:url(#linear-gradient-134);}.cls-126{fill:url(#linear-gradient-135);}.cls-127{fill:url(#linear-gradient-136);}.cls-128{fill:#a27f68;}.cls-129{fill:#172b4d;}.cls-130{fill:#5e6c84;}.cls-131{fill:url(#linear-gradient-137);}.cls-132{fill:url(#linear-gradient-138);}.cls-133{fill:url(#linear-gradient-139);}.cls-134{fill:#72594b;}.cls-135{fill:#ff8b00;}.cls-136{fill:url(#linear-gradient-140);}.cls-137{fill:url(#linear-gradient-141);}.cls-138{fill:url(#linear-gradient-142);}.cls-139{fill:url(#linear-gradient-143);}.cls-140{fill:url(#linear-gradient-144);}.cls-141{fill:url(#linear-gradient-145);}.cls-142{fill:url(#linear-gradient-146);}.cls-143{fill:url(#linear-gradient-147);}.cls-144{fill:url(#linear-gradient-148);}.cls-145{fill:url(#linear-gradient-149);}.cls-146{fill:url(#linear-gradient-150);}.cls-147{fill:url(#linear-gradient-151);}.cls-148{fill:url(#linear-gradient-152);}.cls-149{fill:url(#linear-gradient-153);}.cls-150{fill:url(#linear-gradient-154);}.cls-151{fill:#081d43;}.cls-152{fill:url(#linear-gradient-155);}.cls-153{fill:url(#linear-gradient-156);}.cls-154{fill:url(#linear-gradient-157);}.cls-155{fill:url(#linear-gradient-158);}.cls-156{fill:url(#linear-gradient-159);}.cls-157{fill:url(#linear-gradient-160);}.cls-158{fill:url(#linear-gradient-161);}.cls-159{fill:url(#linear-gradient-162);}.cls-160{fill:url(#linear-gradient-163);}.cls-161{fill:url(#linear-gradient-164);}.cls-162{fill:url(#linear-gradient-165);}.cls-163{fill:url(#linear-gradient-166);}.cls-164{fill:#091e42;}.cls-165{fill:url(#linear-gradient-167);}.cls-166{fill:url(#linear-gradient-168);}.cls-167{fill:url(#linear-gradient-169);}.cls-168{fill:url(#linear-gradient-170);}.cls-169{fill:url(#linear-gradient-171);}.cls-170{fill:url(#linear-gradient-172);}.cls-171{fill:url(#linear-gradient-173);}.cls-172{fill:url(#linear-gradient-174);}.cls-173{fill:url(#linear-gradient-175);}.cls-174{fill:url(#linear-gradient-176);}.cls-175{fill:url(#linear-gradient-177);}.cls-176{fill:url(#linear-gradient-178);}.cls-177{fill:url(#linear-gradient-179);}.cls-178{fill:url(#linear-gradient-180);}.cls-179{fill:url(#linear-gradient-181);}.cls-180{fill:url(#linear-gradient-182);}.cls-181{fill:url(#linear-gradient-183);}.cls-182{fill:url(#linear-gradient-184);}.cls-183{fill:url(#linear-gradient-185);}.cls-184{fill:url(#linear-gradient-186);}.cls-185{fill:url(#linear-gradient-187);}.cls-186{fill:url(#linear-gradient-188);}.cls-187{fill:url(#linear-gradient-189);}.cls-188{fill:url(#linear-gradient-190);}.cls-189{fill:url(#linear-gradient-191);}.cls-190{fill:url(#linear-gradient-192);}.cls-191{fill:url(#linear-gradient-193);}.cls-192{fill:url(#linear-gradient-194);}.cls-193{fill:url(#linear-gradient-195);}.cls-194{fill:url(#linear-gradient-196);}.cls-195{fill:url(#linear-gradient-197);}.cls-196{fill:#fff0b2;}.cls-197{fill:url(#linear-gradient-198);}.cls-198{fill:url(#linear-gradient-199);}.cls-199{fill:url(#linear-gradient-200);}.cls-200{fill:url(#linear-gradient-201);}.cls-201{fill:url(#linear-gradient-202);}.cls-202{fill:url(#linear-gradient-203);}.cls-203{fill:#8c715d;}.cls-204{fill:url(#linear-gradient-204);}.cls-205{fill:url(#linear-gradient-205);}.cls-206{fill:url(#linear-gradient-206);}.cls-207{fill:url(#linear-gradient-207);}.cls-208{fill:url(#linear-gradient-208);}.cls-209{fill:url(#linear-gradient-209);}.cls-210{fill:#cf9e76;}.cls-211{fill:url(#linear-gradient-210);}.cls-212{fill:url(#linear-gradient-211);}.cls-213{fill:url(#linear-gradient-212);}.cls-214{fill:url(#linear-gradient-213);}.cls-215{fill:url(#linear-gradient-214);}.cls-216{fill:#0052cc;}.cls-217{fill:#b08874;}.cls-218{fill:url(#linear-gradient-215);}.cls-219{fill:url(#linear-gradient-216);}.cls-220{opacity:0.21;}.cls-221{fill:url(#linear-gradient-217);}.cls-222{opacity:0.34;}.cls-223{fill:url(#linear-gradient-218);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 184.38,
    y1: 563.24,
    x2: 184.38,
    y2: 299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0065ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#0065ff",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 31.15,
    y1: 563.24,
    x2: 31.15,
    y2: 299,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -26.51,
    y1: 801.27,
    x2: -26.51,
    y2: 717.57,
    gradientTransform: "matrix(0.81, 0.16, 0, 1, 339.1, -281.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#e5e8ec",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#cfd4db",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 261.67,
    y1: 563.24,
    x2: 261.67,
    y2: 299,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -95.45,
    y1: 801.27,
    x2: -95.45,
    y2: 717.57,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -101.38,
    y1: 801.27,
    x2: -101.38,
    y2: 717.57,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 85.43,
    y1: 801.27,
    x2: 85.43,
    y2: 717.57,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 138.87,
    y1: 801.27,
    x2: 138.87,
    y2: 717.57,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 445.6,
    y1: 662.27,
    x2: 403.94,
    y2: 425.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#00c7e5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c7e5",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 103.4,
    y1: 806.88,
    x2: 103.4,
    y2: 719.85,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 144.23,
    y1: 806.88,
    x2: 144.23,
    y2: 719.85,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 86.7,
    y1: 806.88,
    x2: 86.7,
    y2: 719.85,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -306.67,
    y1: 281.08,
    x2: 306.67,
    y2: 281.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2684ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -306.67,
    y1: 270.02,
    x2: 306.67,
    y2: 270.02,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -306.67,
    y1: 277.39,
    x2: 306.67,
    y2: 277.39,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -306.67,
    y1: 279.42,
    x2: 306.67,
    y2: 279.42,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -306.67,
    y1: 287,
    x2: 306.67,
    y2: 287,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 68.45,
    y1: 563.24,
    x2: 68.45,
    y2: 299,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -306.67,
    y1: 304.72,
    x2: 306.67,
    y2: 304.72,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 153.05,
    y1: 563.24,
    x2: 153.05,
    y2: 299,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -306.67,
    y1: 328,
    x2: 306.67,
    y2: 328,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 153.33,
    y1: 563.24,
    x2: 153.33,
    y2: 299,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 168.95,
    y1: 323.17,
    x2: 193.6,
    y2: 462.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#1379fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#379ef9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#54bcf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#69d1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#75def2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79e2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -306.67,
    y1: 298.94,
    x2: 306.67,
    y2: 298.94,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 306.38,
    y1: 298.94,
    x2: 318.52,
    y2: 367.84,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 153.05,
    y1: 563.24,
    x2: 153.05,
    y2: 299,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 152.71,
    y1: 326.04,
    x2: 177.36,
    y2: 465.86,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 294.76,
    y1: -6813.67,
    x2: 477.91,
    y2: -6813.67,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -6608.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79e2f2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#79e2f2",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#79e2f2",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79e2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 197.69,
    y1: -6846.11,
    x2: 345.46,
    y2: -6846.11,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 302.59,
    y1: -6798.43,
    x2: 514.04,
    y2: -6798.43,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 197.69,
    y1: -6866.54,
    x2: 480.79,
    y2: -6866.54,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 4.12,
    y1: 243.15,
    x2: 4.12,
    y2: 55.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0052cc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0052cc",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0052cc",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0052cc",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0052cc",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0052cc",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0052cc",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#0052cc",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0052cc",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0052cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 5.55,
    y1: 243.15,
    x2: 5.55,
    y2: 55.16,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -306.67,
    y1: 241.97,
    x2: 306.67,
    y2: 241.97,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 5.55,
    y1: 243.15,
    x2: 5.55,
    y2: 55.16,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 22.8,
    y1: 243.15,
    x2: 22.8,
    y2: 55.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0065ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0065ff",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#0065ff",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0065ff",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0065ff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#0065ff",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#0065ff",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0065ff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#0065ff",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0065ff",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0065ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 36.69,
    y1: 243.15,
    x2: 36.69,
    y2: 55.16,
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 24.89,
    y1: 243.15,
    x2: 24.89,
    y2: 55.16,
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -306.67,
    y1: 243.02,
    x2: 306.67,
    y2: 243.02,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 11.45,
    y1: 243.15,
    x2: 11.45,
    y2: 55.16,
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 66.63,
    y1: 242.27,
    x2: 88.51,
    y2: 118.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#00a3bf",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#00a3bf",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#00a3bf",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00a3bf",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00a3bf",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00a3bf",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00a3bf",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#00a3bf",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00a3bf",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a3bf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 59.31,
    y1: 240.98,
    x2: 81.19,
    y2: 116.89,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 73.27,
    y1: 243.44,
    x2: 95.15,
    y2: 119.35,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 69.78,
    y1: 242.82,
    x2: 91.65,
    y2: 118.74,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 63.31,
    y1: 241.68,
    x2: 85.19,
    y2: 117.6,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 55.99,
    y1: 240.39,
    x2: 77.87,
    y2: 116.31,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 51.46,
    y1: 239.59,
    x2: 73.34,
    y2: 115.51,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 77.37,
    y1: 244.16,
    x2: 99.25,
    y2: 120.08,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 46.44,
    y1: 238.71,
    x2: 68.32,
    y2: 114.62,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 49.35,
    y1: 239.22,
    x2: 71.23,
    y2: 115.14,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 52.67,
    y1: 239.81,
    x2: 74.55,
    y2: 115.72,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 60.4,
    y1: 241.17,
    x2: 82.28,
    y2: 117.08,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 69.95,
    y1: 242.85,
    x2: 91.83,
    y2: 118.77,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 54.25,
    y1: 240.08,
    x2: 76.13,
    y2: 116,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 126.27,
    y1: 237.16,
    x2: 104.39,
    y2: 113.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#00c7e5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#00c7e5",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00c7e5",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#00c7e5",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00c7e5",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#00c7e5",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00c7e5",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00c7e5",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#00c7e5",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c7e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 96.87,
    y1: 242.35,
    x2: 74.99,
    y2: 118.26,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 119.63,
    y1: 238.33,
    x2: 97.75,
    y2: 114.25,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 128.64,
    y1: 236.74,
    x2: 106.76,
    y2: 112.66,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 111.7,
    y1: 239.73,
    x2: 89.82,
    y2: 115.65,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 122.95,
    y1: 237.75,
    x2: 101.07,
    y2: 113.66,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 105.06,
    y1: 240.9,
    x2: 83.18,
    y2: 116.82,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 98.42,
    y1: 242.07,
    x2: 76.54,
    y2: 117.99,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 97.14,
    y1: 242.3,
    x2: 75.26,
    y2: 118.22,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 101.74,
    y1: 241.49,
    x2: 79.86,
    y2: 117.4,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 108.38,
    y1: 240.32,
    x2: 86.5,
    y2: 116.23,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 116.31,
    y1: 238.92,
    x2: 94.43,
    y2: 114.83,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 113.13,
    y1: 239.48,
    x2: 91.25,
    y2: 115.4,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 109.52,
    y1: 240.12,
    x2: 87.64,
    y2: 116.03,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 70.73,
    y1: 753.62,
    x2: 259.42,
    y2: 564.93,
    gradientTransform: "matrix(0.81, 0.16, 0, 1, 339.1, -281.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f2f5",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e5e8ec",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 36.22,
    y1: 719.11,
    x2: 224.92,
    y2: 530.42,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: -20.1,
    y1: 662.58,
    x2: 168.49,
    y2: 474,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 31.41,
    y1: 714.28,
    x2: 220.1,
    y2: 525.59,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 80.52,
    y1: 763.41,
    x2: 269.21,
    y2: 574.72,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 41.57,
    y1: 724.46,
    x2: 230.26,
    y2: 535.77,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 339.87,
    y1: 293.03,
    x2: 364.53,
    y2: 432.86,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 20.75,
    y1: 703.64,
    x2: 209.44,
    y2: 514.95,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 197.69,
    y1: -6893,
    x2: 480.79,
    y2: -6893,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: -17.03,
    y1: 665.86,
    x2: 171.66,
    y2: 477.17,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 161.28,
    y1: 595.35,
    x2: 323.81,
    y2: 593.16,
    gradientTransform: "matrix(0.81, 0.16, 0, 1, 339.1, -281.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e8ec",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#e5e8ec",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#e5e8ec",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#e5e8ec",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#e5e8ec",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e5e8ec",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#e5e8ec",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#e5e8ec",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#e5e8ec",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 162.8,
    y1: 707.94,
    x2: 325.36,
    y2: 705.74,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 161.15,
    y1: 585.87,
    x2: 323.71,
    y2: 583.67,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 506.76,
    y1: 346.21,
    x2: 619.09,
    y2: 346.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 160.3,
    y1: 523.1,
    x2: 322.86,
    y2: 520.91,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 506.76,
    y1: 283.43,
    x2: 619.09,
    y2: 283.43,
    xlinkHref: "#linear-gradient-102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 133.38,
    y1: 648.2,
    x2: 227.16,
    y2: 554.41,
    gradientTransform: "matrix(0.81, 0.16, 0, 1, 339.1, -281.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f4f5f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 150.89,
    y1: 665.71,
    x2: 244.68,
    y2: 571.93,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 137.45,
    y1: 652.27,
    x2: 231.24,
    y2: 558.48,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 141.12,
    y1: 655.94,
    x2: 234.91,
    y2: 562.15,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 47.68,
    y1: 730.57,
    x2: 236.37,
    y2: 541.88,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 131.71,
    y1: 646.53,
    x2: 225.5,
    y2: 552.75,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 51.35,
    y1: 734.24,
    x2: 240.04,
    y2: 545.54,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 135.38,
    y1: 650.2,
    x2: 229.17,
    y2: 556.41,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 51.11,
    y1: 734,
    x2: 239.81,
    y2: 545.31,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 135.15,
    y1: 649.97,
    x2: 228.94,
    y2: 556.18,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 43.6,
    y1: 726.49,
    x2: 232.3,
    y2: 537.8,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 127.64,
    y1: 642.46,
    x2: 221.43,
    y2: 548.67,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 139.11,
    y1: 653.93,
    x2: 232.9,
    y2: 560.15,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 146.55,
    y1: 661.37,
    x2: 240.33,
    y2: 567.58,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 132.44,
    y1: 647.26,
    x2: 226.23,
    y2: 553.47,
    gradientTransform: "matrix(0, 0.83, -0.98, 0.19, 1077.23, 116.29)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 125.91,
    y1: 640.73,
    x2: 219.7,
    y2: 546.94,
    gradientTransform: "matrix(0, 0.83, -0.98, 0.19, 1066.66, 125)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 144.68,
    y1: 659.5,
    x2: 238.46,
    y2: 565.71,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 120.39,
    y1: 635.22,
    x2: 214.18,
    y2: 541.43,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 149.64,
    y1: 664.47,
    x2: 243.43,
    y2: 570.68,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 117.52,
    y1: 632.34,
    x2: 211.3,
    y2: 538.55,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 161.67,
    y1: 623.99,
    x2: 324.22,
    y2: 621.8,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 168.43,
    y1: 683.25,
    x2: 262.21,
    y2: 589.46,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 161.35,
    y1: 600.37,
    x2: 323.9,
    y2: 598.18,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 143.19,
    y1: 658.01,
    x2: 236.98,
    y2: 564.22,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 161.24,
    y1: 592.23,
    x2: 323.79,
    y2: 590.03,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 139.11,
    y1: 653.94,
    x2: 232.9,
    y2: 560.15,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 161.35,
    y1: 600.66,
    x2: 323.91,
    y2: 598.46,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 506.76,
    y1: 355.71,
    x2: 619.09,
    y2: 355.71,
    xlinkHref: "#linear-gradient-102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 161.69,
    y1: 676.51,
    x2: 255.47,
    y2: 582.72,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 147.48,
    y1: 662.3,
    x2: 241.27,
    y2: 568.52,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 160.69,
    y1: 675.52,
    x2: 254.48,
    y2: 581.73,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 173.78,
    y1: 688.6,
    x2: 267.57,
    y2: 594.81,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 62.42,
    y1: 563.24,
    x2: 62.42,
    y2: 299,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: -306.67,
    y1: 316.62,
    x2: 306.67,
    y2: 316.62,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 25.49,
    y1: 316.62,
    x2: 99.36,
    y2: 316.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 70.67,
    y1: 265.39,
    x2: 112.65,
    y2: 223.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff991f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 44.47,
    y1: 239.19,
    x2: 86.45,
    y2: 197.21,
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 63.47,
    y1: 258.18,
    x2: 105.45,
    y2: 216.21,
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 64.63,
    y1: 241.91,
    x2: 86.51,
    y2: 117.83,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 50.26,
    y1: 244.98,
    x2: 92.24,
    y2: 203,
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 98.42,
    y1: 242.07,
    x2: 76.54,
    y2: 117.99,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 62.86,
    y1: 257.57,
    x2: 104.84,
    y2: 215.59,
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 86.91,
    y1: 244.1,
    x2: 65.03,
    y2: 120.02,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 51.85,
    y1: 246.56,
    x2: 93.83,
    y2: 204.58,
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 68.27,
    y1: 262.98,
    x2: 110.25,
    y2: 221.01,
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 68.17,
    y1: 262.88,
    x2: 110.15,
    y2: 220.9,
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 69.33,
    y1: 264.05,
    x2: 111.31,
    y2: 222.07,
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 40.86,
    y1: 235.57,
    x2: 82.84,
    y2: 193.6,
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 47.39,
    y1: 242.11,
    x2: 89.37,
    y2: 200.13,
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 56.56,
    y1: 251.27,
    x2: 98.54,
    y2: 209.29,
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: -241.85,
    y1: 186.84,
    x2: -231.37,
    y2: 186.84,
    gradientTransform: "translate(403.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#72594b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8c715d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: -241.85,
    y1: 181.85,
    x2: -231.37,
    y2: 181.85,
    xlinkHref: "#linear-gradient-155"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: -241.85,
    y1: 176.69,
    x2: -231.37,
    y2: 176.69,
    xlinkHref: "#linear-gradient-155"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: -241.85,
    y1: 181.59,
    x2: -231.37,
    y2: 181.59,
    xlinkHref: "#linear-gradient-155"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: -4272.61,
    y1: 192.27,
    x2: -4285.12,
    y2: 204.85,
    gradientTransform: "matrix(-1, 0, 0, 1, -4119.42, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffc202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ffb00f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ffa318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ff9b1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff991f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: -4262.24,
    y1: 202.59,
    x2: -4274.75,
    y2: 215.17,
    xlinkHref: "#linear-gradient-159"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: -4265.23,
    y1: 199.62,
    x2: -4277.74,
    y2: 212.19,
    xlinkHref: "#linear-gradient-159"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: -4266.14,
    y1: 198.71,
    x2: -4278.65,
    y2: 211.28,
    xlinkHref: "#linear-gradient-159"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: -4278.44,
    y1: 186.48,
    x2: -4290.95,
    y2: 199.06,
    xlinkHref: "#linear-gradient-159"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: -4263.69,
    y1: 201.14,
    x2: -4276.2,
    y2: 213.72,
    xlinkHref: "#linear-gradient-159"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: -4267.55,
    y1: 197.31,
    x2: -4280.06,
    y2: 209.89,
    xlinkHref: "#linear-gradient-159"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: -4264.47,
    y1: 200.36,
    x2: -4276.99,
    y2: 212.94,
    xlinkHref: "#linear-gradient-159"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: -306.67,
    y1: 294.03,
    x2: 306.67,
    y2: 294.03,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 115.59,
    y1: 294.03,
    x2: 186.61,
    y2: 294.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#e5e8ec",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#cfd4db",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 151.1,
    y1: 563.24,
    x2: 151.1,
    y2: 299,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: -306.67,
    y1: 300.62,
    x2: 306.67,
    y2: 300.62,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 115.59,
    y1: 300.62,
    x2: 186.61,
    y2: 300.62,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 115.59,
    y1: 293.29,
    x2: 186.61,
    y2: 293.29,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 115.59,
    y1: 294.83,
    x2: 186.61,
    y2: 294.83,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: -4286.34,
    y1: 218.94,
    x2: -4286.34,
    y2: 183.24,
    gradientTransform: "matrix(-1, 0, 0, 1, -4119.42, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff991f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#ffc400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: -4280.17,
    y1: 218.94,
    x2: -4280.17,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: -4280.89,
    y1: 218.94,
    x2: -4280.89,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: -4295.56,
    y1: 218.94,
    x2: -4295.56,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: -4286.69,
    y1: 218.94,
    x2: -4286.69,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: -4280.27,
    y1: 218.94,
    x2: -4280.27,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: -4279.52,
    y1: 218.94,
    x2: -4279.52,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: -4291.6,
    y1: 218.94,
    x2: -4291.6,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: -4288.35,
    y1: 218.94,
    x2: -4288.35,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: -241.85,
    y1: 187.48,
    x2: -231.37,
    y2: 187.48,
    xlinkHref: "#linear-gradient-155"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: -4284.73,
    y1: 218.94,
    x2: -4284.73,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: -241.85,
    y1: 186.43,
    x2: -231.37,
    y2: 186.43,
    xlinkHref: "#linear-gradient-155"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: -4291.88,
    y1: 218.94,
    x2: -4291.88,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: -241.85,
    y1: 188.2,
    x2: -231.37,
    y2: 188.2,
    xlinkHref: "#linear-gradient-155"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: -4287.98,
    y1: 218.94,
    x2: -4287.98,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: -241.85,
    y1: 186.43,
    x2: -231.37,
    y2: 186.43,
    xlinkHref: "#linear-gradient-155"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: -4289.97,
    y1: 218.94,
    x2: -4289.97,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: -4275.48,
    y1: 189.42,
    x2: -4287.99,
    y2: 202,
    xlinkHref: "#linear-gradient-159"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: -4276.61,
    y1: 218.94,
    x2: -4276.61,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: -4278.47,
    y1: 186.45,
    x2: -4290.98,
    y2: 199.02,
    xlinkHref: "#linear-gradient-159"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: -4276.7,
    y1: 218.94,
    x2: -4276.7,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: -4289.24,
    y1: 218.94,
    x2: -4289.24,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: -4280.35,
    y1: 218.94,
    x2: -4280.35,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: -241.85,
    y1: 186.99,
    x2: -231.37,
    y2: 186.99,
    xlinkHref: "#linear-gradient-155"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: -4285.03,
    y1: 218.94,
    x2: -4285.03,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: -4284.18,
    y1: 218.94,
    x2: -4284.18,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: -4284.53,
    y1: 218.94,
    x2: -4284.53,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: -241.85,
    y1: 187.56,
    x2: -231.37,
    y2: 187.56,
    xlinkHref: "#linear-gradient-155"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: -4285.38,
    y1: 218.94,
    x2: -4285.38,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: -4283.88,
    y1: 218.94,
    x2: -4283.88,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: -4299.4,
    y1: 199.27,
    x2: -4292.05,
    y2: 203.56,
    gradientTransform: "matrix(-1, 0, 0, 1, -4119.42, 0)",
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: -4295.95,
    y1: 218.94,
    x2: -4295.95,
    y2: 183.24,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: -4298.19,
    y1: 197.2,
    x2: -4290.84,
    y2: 201.49,
    gradientTransform: "matrix(-1, 0, 0, 1, -4119.42, 0)",
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: -4302.97,
    y1: 205.39,
    x2: -4295.63,
    y2: 209.68,
    gradientTransform: "matrix(-1, 0, 0, 1, -4119.42, 0)",
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 79.56,
    y1: 806.88,
    x2: 79.56,
    y2: 719.85,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 366.4,
    y1: 501.39,
    x2: 440.89,
    y2: 501.39,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 30.24,
    y1: 713.13,
    x2: 218.93,
    y2: 524.44,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 2899.13,
    y1: 410.88,
    x2: 2912.57,
    y2: 410.88,
    gradientTransform: "matrix(-1, 0, 0, 1, 3292.2, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0049b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0052cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 25.48,
    y1: 708.37,
    x2: 214.17,
    y2: 519.68,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 2899.13,
    y1: 407.13,
    x2: 2912.57,
    y2: 407.13,
    xlinkHref: "#linear-gradient-211"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 2899.13,
    y1: 406.26,
    x2: 2912.57,
    y2: 406.26,
    xlinkHref: "#linear-gradient-211"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 161.11,
    y1: 582.74,
    x2: 323.67,
    y2: 580.54,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 506.76,
    y1: 348.71,
    x2: 619.09,
    y2: 348.71,
    xlinkHref: "#linear-gradient-102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 161.93,
    y1: 643.76,
    x2: 324.49,
    y2: 641.57,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 654.18,
    y1: 729.37,
    x2: 166,
    y2: 410.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c7e5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00c7e5",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00c7e5",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00c7e5",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0bb3ed",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2684ff",
    stopOpacity: 0.2
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cobra id pages_default_left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.12 165.58 38.68 162.65 38.68 178.48 54.12 181.41 54.12 165.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.12 88.2 38.68 85.27 38.68 100.85 54.12 103.78 54.12 88.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "328.54 435.7 328.54 435.7 359.09 429.91 359.09 429.91 306.66 439.84 306.66 439.84 328.54 435.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "81.98 106.94 99.99 110.36 99.99 96.89 80.57 93.21 80.57 107.21 81.98 106.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.12 107.35 38.68 104.43 38.68 120.26 54.12 123.18 54.12 107.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "76.41 108 77.05 107.88 77.05 92.54 57.63 88.86 57.63 104.44 76.41 108"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.12 126.76 38.68 123.84 38.68 139.67 54.12 142.59 54.12 126.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.25,246q1.38-3.37,2.77-6.77a45.19,45.19,0,0,0,.35-6.6,49.41,49.41,0,0,0-.92-8.17c-.23-1.32-.54-2.85-1-4.55a5.77,5.77,0,0,1,1.91-5.81v-7.39a9.19,9.19,0,0,1-1.07-2.17l-14.65-2.78v36.21L11.8,243l39.86,7.55a31.23,31.23,0,0,1,.64-4C51.85,246.34,51.5,246.12,51.25,246Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "488.18 450.7 498.16 452.6 498.16 391.02 488.18 389.07 488.18 450.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.76,197.3A6.11,6.11,0,0,1,51.65,191a5.5,5.5,0,0,1,2.47-.64V185l-15.44-2.93v15.83l11.44,2.17A5.34,5.34,0,0,1,48.76,197.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.12 146.17 38.68 143.24 38.68 159.08 54.12 162 54.12 146.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.58,205.48a18.87,18.87,0,0,1-3.89-1,15.49,15.49,0,0,1-3.63-1.84c-.89-.6-2-1.4-3.35-2.39l-8.27-1.57v15.83l19.42,3.68V205.6l-.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.85,197c-.93,1-2,2.12-3.24,3.45l2.82.53A15.1,15.1,0,0,0,157.85,197Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.86 163.55 126.44 159.87 126.44 175.7 145.86 179.38 145.86 163.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.65,195.39a3.6,3.6,0,0,1-.59-.27c-.05.08-.12.17-.19.26l1,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128,191.05a1.74,1.74,0,0,1,.26.15v0c.65.36,1.72.93,3.07,1.53,3.54,1.57,5.38,1.79,8.68,3.12a40,40,0,0,1,4.85,2.37h0a8.6,8.6,0,0,1,1-1.6V183l-19.42-3.68v11.19a5.39,5.39,0,0,1,.68.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.79,187.55a26.53,26.53,0,0,1,2-2.52l-7.43-1.4v10.5C151.69,193.39,152.55,190.72,154.79,187.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.86 144.14 126.44 140.46 126.44 156.29 145.86 159.97 145.86 144.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.56,191.91l9.71,1.84a.78.78,0,0,1,.43-.64.61.61,0,0,1-.08-.62.59.59,0,0,1,.56-.35l1.73-.39a1.37,1.37,0,0,1-1-1.31l2-.09V178.61l-13.36-2.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "109.56 112.17 109.56 114.28 122.92 116.81 122.92 101.23 103.5 97.55 103.5 111.02 109.56 112.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.14,260.93c-.18-.93-.54-2.7-1-5.22-.91-5.35-1.1-7.89-1.94-13.58-.26-1.81-.67-4.47-1.24-7.71l-2.76,25.66c.09,3,.15,5.77.18,8.13,0,.77,0,1.91,0,3.36l8.87,1.68C170.5,268.24,169.77,264.18,169.14,260.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.86 124.73 126.44 121.06 126.44 136.89 145.86 140.57 145.86 124.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.79,210.56c-.15-.1-.31-.22-.47-.35,0,.12,0,.22-.06.35-.07.53-.13,1-.18,1.52.2-.45.44-1,.72-1.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "109.56 172.5 122.92 175.04 122.92 159.21 109.56 156.67 109.56 172.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "149.37 125.4 149.37 141.23 168.79 144.91 168.79 127.22 168.45 129.02 149.37 125.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "168.79 125.5 168.79 109.93 149.37 106.25 149.37 121.82 168.79 125.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.86 121.16 145.86 105.58 126.44 101.9 126.44 117.48 145.86 121.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.37,180.05l12.83,2.43.41-.4,1.07-.3a5.59,5.59,0,0,0,0-.62V181c-2.11.29-2.45.28-2.81,0s-.59-1.16-1.08-2.92c-.25-.88-.43-1.62-.55-2.15-.29.08-1.08.29-1.32,0s0-.59.26-1.17a15.81,15.81,0,0,0,.68-2.21c0-.14,0-.3,0-.45a8.69,8.69,0,0,1,.09-1.48h0l.09-.46a.13.13,0,0,0,0-.06c0-.17.09-.34.14-.52a6.23,6.23,0,0,1,.53-1.17,8.26,8.26,0,0,1,1.44-1.87l-11.78-2.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "149.37 144.81 149.37 160.64 168.79 164.32 168.79 146.63 168.45 148.42 149.37 144.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.65,209.76a10.29,10.29,0,0,0-.33-3,11.45,11.45,0,0,1-.3-2.31l-5.3-1a8.72,8.72,0,0,1-2.35,1.8v13.59l7.23,1.37q.35-3,.72-5.91h0c0-.57,0-1.33.11-2.24C157.53,211,157.63,210.54,157.65,209.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "109.56 153.1 122.92 155.63 122.92 139.8 109.56 137.26 109.56 153.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "109.56 133.69 122.92 136.22 122.92 120.39 109.56 117.86 109.56 133.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "57.63 108.02 57.63 111.56 66.97 109.79 57.63 108.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.3,217.24h0a9.74,9.74,0,0,1,.4,2.07,3.1,3.1,0,0,1,.08.5,1.84,1.84,0,0,1-.39,1c-1.14,1.44-1.78,2.22-2.11,2.61.33.42.64.84.93,1.25-1.39,1-2.61,1.85-3.65,2.55v12.49L82,245l-4.15-.78.07.25c-.19.15-.41.34-.66.53.17.65.28,1.19.35,1.57.64,3.46,1.16,6.53,1.59,9.25l75.42,14.29c-.32-9.93-.25-20.46.41-31.55.3-5,.71-9.83,1.2-14.54l-42.4-8C114,216.46,114.18,216.9,114.3,217.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.23,208.46a.9.9,0,0,1,.76,1.14l-.75,2.61,8.68,1.64V198l-13.36-2.53v12.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "306.66 439.84 306.66 439.84 62.1 486.18 216.68 456.89 306.66 439.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "62.1 486.18 0 357 0 357 0 563.24 62.29 563.24 62.29 486.22 62.1 486.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M624.53,483.54,501.32,459.27c-1.75-.34-3.16-2.4-3.16-4.59v-2.09l-10-1.89v2.46c0,2.17-1.42,3.66-3.16,3.32l-68.24-13.34c.14.46.29.92.43,1.38l.15-.06c.31,1,.63,2.05.94,3.09l-.1,0c.31,1,.61,1.9.92,2.84l.07,0c.29.92.57,1.84.87,2.77l0,0,.21.61c34.34,6.58,64.69,12.31,64.69,12.31l-63.9,14c0,.49.08,1,.12,1.47h.05c0,.46.06,1.1.1,1.83l.06.64h0c.05.74.1,1.55.14,2.35l73.17-15.63,131.65,24.72L437.68,531.23l237.55-45,.2,0-47.74-9v3.05C627.69,482.39,626.28,483.89,624.53,483.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M402.15,490.33c0,.07,0,.13,0,.2l13.32-2.84c-.2-1-.36-1.91-.5-2.91h0c-.16-.86-.29-2.08-.38-3.23l-11.79,2.59A50.63,50.63,0,0,1,402.15,490.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M385,444.38c0,.39.08,1.18-.19,1.43s-.4-.09-.61-.09c-.15-.75-.31-1.5-.46-2.24-.13,1-.24,2.16-.36,3.22l7.54,1.46c0-2.67,0-5.06,0-6.67,0-1.16.07-2.28.11-3.37l-7.91-1.54c0,.18,0,.36-.05.55.21.47.49,1.09.65,1.49A18.81,18.81,0,0,1,385,444.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M379.59,446a22,22,0,0,1,.25-5.94h0c0-1.37,0-2.74,0-4.11l-18-3.51a4,4,0,0,1-2.71-2.49l-30.55,5.79C337.17,437.62,356.93,441.55,379.59,446Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M285.92,515.35l111-23.71c-.05-.44-.11-.88-.17-1.36-.11-.81-.38-2.85-.63-4.7L285.92,509.75s-133.15-27.16-168.45-34.06l99.21-18.8L62.1,486.18l.19,0,244.37,46.3,62.1,11.77,39.54-7.49S321.22,522.25,285.92,515.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "328.54 435.7 328.54 435.7 306.66 439.84 306.66 439.84 328.54 435.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "306.66 439.84 216.68 456.89 306.66 439.84 306.66 439.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "306.66 439.84 216.68 456.89 306.66 439.84 306.66 439.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M395.82,482.79a58.7,58.7,0,0,1-.06-11.17c.1-1.13.31-2.42.49-3.56-.4-1.61-.74-3.17-1-4.76-1.2-.17-2.41-.38-3.64-.66-.15-1.3-.27-2.88-.37-4.59h0c-.08-1.08-.14-2.15-.19-3.22h.08c0-1-.06-1.93-.08-2.9h-.09c0-1,0-1.95,0-2.91H391c0-.29,0-.57,0-.85l-7.54-1.46c0,.39-.09.76-.14,1.11a1.4,1.4,0,0,1-1.16,1.32h0c-.69.13-1.79-.84-2.23-1.39a16,16,0,0,1-.28-1.78c-22.66-4.41-42.42-8.34-51-10.26l-21.88,4.14-90,17.05-99.21,18.8c35.3,6.9,168.45,34.06,168.45,34.06l110.23-24.17c-.15-1.1-.28-2.12-.37-2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M395.82,482.79a58.7,58.7,0,0,1-.06-11.17c.1-1.13.31-2.42.49-3.56-.4-1.61-.74-3.17-1-4.76-1.2-.17-2.41-.38-3.64-.66-.15-1.3-.27-2.88-.37-4.59h0c-.08-1.08-.14-2.15-.19-3.22h.08c0-1-.06-1.93-.08-2.9h-.09c0-1,0-1.95,0-2.91H391c0-.29,0-.57,0-.85l-7.54-1.46c0,.39-.09.76-.14,1.11a1.4,1.4,0,0,1-1.16,1.32h0c-.69.13-1.79-.84-2.23-1.39a16,16,0,0,1-.28-1.78c-22.66-4.41-42.42-8.34-51-10.26l-21.88,4.14-90,17.05-99.21,18.8c35.3,6.9,168.45,34.06,168.45,34.06l110.23-24.17c-.15-1.1-.28-2.12-.37-2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M402.52,470.33a35.47,35.47,0,0,0,.22,5.2,46.5,46.5,0,0,1,0,7.47h-.44l.44,0c0,.36,0,.74,0,1.11l11.79-2.59c-.07-.89-.11-1.74-.11-2.33a40.62,40.62,0,0,0-.17-7.13,12.05,12.05,0,0,0-.88-3c-.62-1.31-1.64-3.47-2.06-4.48-.24-.58-.52-1.42-.81-2.35-.77.22-1.54.42-2.33.58a42.89,42.89,0,0,1-4.25.65,11.31,11.31,0,0,1-.48,2.5A27.63,27.63,0,0,0,402.52,470.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M402.52,470.33a35.47,35.47,0,0,0,.22,5.2,46.5,46.5,0,0,1,0,7.47h-.44l.44,0c0,.36,0,.74,0,1.11l11.79-2.59c-.07-.89-.11-1.74-.11-2.33a40.62,40.62,0,0,0-.17-7.13,12.05,12.05,0,0,0-.88-3c-.62-1.31-1.64-3.47-2.06-4.48-.24-.58-.52-1.42-.81-2.35-.77.22-1.54.42-2.33.58a42.89,42.89,0,0,1-4.25.65,11.31,11.31,0,0,1-.48,2.5A27.63,27.63,0,0,0,402.52,470.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M418.6,458.85c.63,3.65,1.2,6.62,1.82,10.15.08,2.33.18,4.72.32,7.07.08,1.35.17,2.7.28,4.05l63.9-14s-30.35-5.73-64.69-12.31c.37,1.15.75,2.29,1.11,3.41C420.44,457.79,419.53,458.33,418.6,458.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M418.6,458.85c.63,3.65,1.2,6.62,1.82,10.15.08,2.33.18,4.72.32,7.07.08,1.35.17,2.7.28,4.05l63.9-14s-30.35-5.73-64.69-12.31c.37,1.15.75,2.29,1.11,3.41C420.44,457.79,419.53,458.33,418.6,458.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "408.3 536.8 437.68 531.23 408.3 536.8 408.3 536.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "408.3 536.8 437.68 531.23 408.3 536.8 408.3 536.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M494.64,470.77,421.47,486.4c.12,2,.21,3.92.16,4.65a30.85,30.85,0,0,0,0,4.3c11.47,1.18,19.24,3.44,19.24,6,0,3.82-16.67,6.91-37.25,6.91s-37.24-3.09-37.24-6.91c0-3.41,13.35-6.24,30.89-6.8-.08-.91-.19-1.87-.34-2.95l-111,23.71c35.3,6.9,122.38,21.45,122.38,21.45l29.38-5.57,188.61-35.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M494.64,470.77,421.47,486.4c.12,2,.21,3.92.16,4.65a30.85,30.85,0,0,0,0,4.3c11.47,1.18,19.24,3.44,19.24,6,0,3.82-16.67,6.91-37.25,6.91s-37.24-3.09-37.24-6.91c0-3.41,13.35-6.24,30.89-6.8-.08-.91-.19-1.87-.34-2.95l-111,23.71c35.3,6.9,122.38,21.45,122.38,21.45l29.38-5.57,188.61-35.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M401.42,494.5h2.22c4.89,0,9.55.17,13.82.49a30.08,30.08,0,0,0-.86-3.1,35.73,35.73,0,0,1-1.17-4.19l-13.32,2.84C401.87,492,401.64,493.21,401.42,494.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M401.42,494.5h2.22c4.89,0,9.55.17,13.82.49a30.08,30.08,0,0,0-.86-3.1,35.73,35.73,0,0,1-1.17-4.19l-13.32,2.84C401.87,492,401.64,493.21,401.42,494.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M171.32,273.25l-8.87-1.68c0,.32,0,.64,0,1,0,4.78,0,10.35-.16,16.84,4.28.27,8.2.68,11.58,1.2C173,283.85,172.11,278.1,171.32,273.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M52.74,297.19l.79.06a50.77,50.77,0,0,1-1.13-12.74,51.3,51.3,0,0,1,.71-6.82q-.26-3.69-.67-7.6-.36-3.39-.81-6.59a82,82,0,0,1,0-12.93L11.8,243l-.7.13L0,241.05V299H53C52.9,298.42,52.82,297.82,52.74,297.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M115.59,295.65c0-3.63,15.9-6.58,35.51-6.58,1.58,0,3.12,0,4.65.06q-.81-9.09-1.15-19.05L79.18,255.79c2,12.36,2.1,17.26,2.1,17.26s.4,12.19.53,25.95h38.71C117.39,298,115.59,296.87,115.59,295.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M60.62,299H73c-.55-1.73-.94-3.27-1.23-4.55a36.09,36.09,0,0,1-1.16-8.31,32.22,32.22,0,0,1,.91-7.92,69,69,0,0,0-2.68-7.05,68.56,68.56,0,0,0-6.39-11.33q-.57,11.1-1.27,22.4-.46,7.47-1,14.84l.39-.05C60.56,297.58,60.58,298.25,60.62,299Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M181,291.55c.08.19.15.39.22.61,3.43,1,5.42,2.21,5.42,3.49s-1.8,2.37-4.93,3.35H306.09l.57-.11h0L180.57,275l1,16.4C181.37,291.46,181.17,291.5,181,291.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M60.84,302c.38,3.86.64,6.26,1.56,8h0c4.9,0,9.58.17,13.86.48-.23-.7-.47-1.43-.72-2.22-.58-1.77-1.41-4.38-2.36-7.65h.29c-.19-.54-.36-1.06-.52-1.57H60.62C60.67,299.88,60.74,300.88,60.84,302Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M60.84,302c.38,3.86.64,6.26,1.56,8h0c4.9,0,9.58.17,13.86.48-.23-.7-.47-1.43-.72-2.22-.58-1.77-1.41-4.38-2.36-7.65h.29c-.19-.54-.36-1.06-.52-1.57H60.62C60.67,299.88,60.74,300.88,60.84,302Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M306.09,299H181.68c-6.18,1.93-17.56,3.23-30.58,3.23s-24.4-1.3-30.58-3.23H81.81c0,.12,0,.24,0,.37l.13-.05c.08.86.19,2.15.3,3.72.13,2,.12,2.63.3,3.88a19.93,19.93,0,0,0,.7,3.15c.1.33.22.69.37,1.09,9.51,1.2,15.74,3.2,15.74,5.46,0,3.69-16.54,6.68-36.94,6.68s-36.93-3-36.93-6.68c0-3.21,12.55-5.89,29.26-6.53a52.54,52.54,0,0,0-1-6.35c-.24-1.18-.53-2.79-.8-4.74H0v58H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M306.09,299H181.68c-6.18,1.93-17.56,3.23-30.58,3.23s-24.4-1.3-30.58-3.23H81.81c0,.12,0,.24,0,.37l.13-.05c.08.86.19,2.15.3,3.72.13,2,.12,2.63.3,3.88a19.93,19.93,0,0,0,.7,3.15c.1.33.22.69.37,1.09,9.51,1.2,15.74,3.2,15.74,5.46,0,3.69-16.54,6.68-36.94,6.68s-36.93-3-36.93-6.68c0-3.21,12.55-5.89,29.26-6.53a52.54,52.54,0,0,0-1-6.35c-.24-1.18-.53-2.79-.8-4.74H0v58H0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "306.66 299 306.1 299 0 357 62.1 486.18 306.66 439.84 306.66 299"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M358.65,427.84V407.05l-52-108.16-.56.11L0,357,62.1,486.18l244.56-46.34,52.43-9.93A5.16,5.16,0,0,1,358.65,427.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "306.09 299 306.1 299 306.66 298.89 306.66 298.89 306.09 299"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "306.09 299 306.1 299 306.66 298.89 306.66 298.89 306.09 299"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "306.09 299 0 357 306.1 299 306.09 299"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "306.09 299 0 357 306.1 299 306.09 299"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "306.09 299 0 357 306.1 299 306.09 299"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "114.24 212.21 114.17 212.45 122.92 214.11 122.92 213.85 114.24 212.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "126.44 214.52 126.44 214.77 145.86 218.45 145.86 218.2 126.44 214.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M50.16,200.11l0-.05-11.44-2.17v.26l11.74,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M149.37,219.12l7.2,1.36,0-.24-7.23-1.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "54.12 181.41 38.68 178.48 38.68 182.06 54.12 184.99 54.12 181.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M128.86,195.57l-1-.19a3,3,0,0,1-.53.55,2.5,2.5,0,0,1-.9.43v2.33l8.27,1.57C133.07,199,131.11,197.48,128.86,195.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M122.92,196.52H122a1,1,0,0,1-.7-.32.91.91,0,0,1-.23-.6c-.66.14-1.2-.12-1.3-.48a.72.72,0,0,1,.11-.56.81.81,0,0,1-.61-.78v0l-9.71-1.84v3.58L122.92,198Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M157.43,201l-2.82-.53-2.31,2.43-.58.6,5.3,1A15.41,15.41,0,0,1,157.43,201Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "145.86 179.38 126.44 175.7 126.44 179.28 145.86 182.96 145.86 179.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M157.55,184.23h0a3.14,3.14,0,0,1,2.5-1c.46,0,.9.05,1.31.05l.84-.82-12.83-2.43v3.58l7.43,1.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "109.56 176.08 122.92 178.62 122.92 175.04 109.56 172.5 109.56 176.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "54.12 162 38.68 159.08 38.68 162.65 54.12 165.58 54.12 162"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "109.56 156.67 122.92 159.21 122.92 155.63 109.56 153.1 109.56 156.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "54.12 142.59 38.68 139.67 38.68 143.24 54.12 146.17 54.12 142.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "145.86 159.97 126.44 156.29 126.44 159.87 145.86 163.55 145.86 159.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M149.37,164.22l11.78,2.23c.19-.19.33-.31.36-.34a7.84,7.84,0,0,1,1.24-.82,7.7,7.7,0,0,1,6-.61v-.36l-19.42-3.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "149.37 144.81 168.45 148.42 168.79 146.63 168.79 144.91 149.37 141.23 149.37 144.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "109.56 137.26 122.92 139.8 122.92 136.22 109.56 133.69 109.56 137.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "145.86 140.57 126.44 136.89 126.44 140.46 145.86 144.14 145.86 140.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "54.12 123.18 38.68 120.26 38.68 123.84 54.12 126.76 54.12 123.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "149.37 125.4 168.45 129.02 168.79 127.22 168.79 125.5 149.37 121.82 149.37 125.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "122.92 120.39 122.92 116.81 109.56 114.28 109.56 117.86 122.92 120.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "76.41 108 57.63 104.44 57.63 108.02 66.97 109.79 76.41 108"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "145.86 121.16 126.44 117.48 126.44 121.06 145.86 124.73 145.86 121.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "54.12 103.78 38.68 100.85 38.68 104.43 54.12 107.35 54.12 103.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M54.12,107.35v83h.28V112.17l3.23-.61V88.86l-3.51-.66v19.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "80.57 107.21 80.57 93.21 77.05 92.54 77.05 107.88 80.57 107.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "103.5 111.02 103.5 97.55 99.99 96.89 99.99 110.36 103.5 111.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M126.44,198.69v-2.33a10.44,10.44,0,0,1-1.29.24s-.84-.06-2.23-.08v17.59l3.52.66V198.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M122.92,120.39v70l1.69-.07a6.26,6.26,0,0,1,1.83.19V101.9l-3.52-.67v19.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M145.86,205.6v12.85l3.51.67V205.28a5.09,5.09,0,0,1-1.43.45A5.39,5.39,0,0,1,145.86,205.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M145.86,124.73v71.84a6.34,6.34,0,0,1,2.47-2.07,5,5,0,0,1,1-.34l.06,0V106.25l-3.51-.67v19.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M171.83,182.45l.06-.08.42.8v-6a18,18,0,0,0-.5,3.71C171.79,181.44,171.8,182,171.83,182.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M168.79,109.93v54.75a5.76,5.76,0,0,1,1,.45,7,7,0,0,1,2.5,2.35V107.21h-2.44l-.53,2.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "54.12 88.2 57.63 88.86 77.05 92.54 80.57 93.21 99.99 96.89 103.5 97.55 122.92 101.23 126.44 101.9 145.86 105.58 149.37 106.25 168.79 109.93 169.34 110.03 169.87 107.21 169.99 106.58 38.68 81.7 38.68 85.27 54.12 88.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M53,203.14a9.31,9.31,0,0,1-.14-1.59,3.86,3.86,0,0,1-2.43-1.18l-11.74-2.22v3.57l14.65,2.78A8.33,8.33,0,0,1,53,203.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M192.26,230.82l.65-3.45-16.19-3.07c.12,1.21.25,2.43.37,3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M145.86,218.45l-19.42-3.68-3.52-.66-8.75-1.66-.75,2.61.39.9,42.4,8c.12-1.17.23-2.35.36-3.51l-7.2-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M294.79,187.61a1.76,1.76,0,0,0,1.4,2l179.64,34a1.84,1.84,0,0,0,.33,0,1.76,1.76,0,0,0,.32-3.48l-179.63-34A1.77,1.77,0,0,0,294.79,187.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M197.72,223.4a1.76,1.76,0,0,0,1.4,2l144.25,27.33a1.84,1.84,0,0,0,.33,0,1.76,1.76,0,0,0,.33-3.48L199.78,222A1.77,1.77,0,0,0,197.72,223.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M512,211.14l.33,0a1.76,1.76,0,0,0,.32-3.49l-207.94-39.4a1.76,1.76,0,0,0-.65,3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M199.78,241a1.76,1.76,0,1,0-.66,3.45l159.53,30.23V271.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "38.68 55.16 11.1 49.94 0 52.04 0 58.29 11.1 60.39 38.68 55.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "8.25 177.55 0 179.11 0 194.94 8.25 193.38 8.25 177.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "8.25 158.14 0 159.7 0 175.53 8.25 173.97 8.25 158.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "11.1 242.89 11.1 196.5 10.89 196.46 0 198.52 0 240.79 0 240.79 11.1 242.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "8.25 119.33 0 120.89 0 136.72 8.25 135.16 8.25 119.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "8.25 80.51 0 82.07 0 97.9 8.25 96.34 8.25 80.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "8.25 138.73 0 140.29 0 156.13 8.25 154.56 8.25 138.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "8.25 99.92 0 101.48 0 117.31 8.25 115.75 8.25 99.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "10.81 77.8 10.9 77.8 10.9 77.38 11.05 77.38 11.1 77.1 11.1 60.39 0 58.29 0 78.49 10.56 76.49 10.81 77.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "11.1 242.89 0 240.79 0 240.79 0 241.05 11.1 243.16 11.1 242.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "11.1 242.89 0 240.79 0 240.79 0 241.05 11.1 243.16 11.1 242.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "11.1 196.5 11.1 77.1 11.05 77.38 10.9 77.38 10.9 77.8 10.81 77.8 10.56 76.49 0 78.49 0 82.07 8.25 80.51 8.25 96.34 0 97.9 0 101.48 8.25 99.92 8.25 115.75 0 117.31 0 120.89 8.25 119.33 8.25 135.16 0 136.72 0 140.29 8.25 138.73 8.25 154.56 0 156.13 0 159.7 8.25 158.14 8.25 173.97 0 175.53 0 179.11 8.25 177.55 8.25 193.38 0 194.94 0 198.52 10.89 196.46 11.1 196.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "11.1 196.5 11.1 77.1 11.05 77.38 10.9 77.38 10.9 77.8 10.81 77.8 10.56 76.49 0 78.49 0 82.07 8.25 80.51 8.25 96.34 0 97.9 0 101.48 8.25 99.92 8.25 115.75 0 117.31 0 120.89 8.25 119.33 8.25 135.16 0 136.72 0 140.29 8.25 138.73 8.25 154.56 0 156.13 0 159.7 8.25 158.14 8.25 173.97 0 175.53 0 179.11 8.25 177.55 8.25 193.38 0 194.94 0 198.52 10.89 196.46 11.1 196.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "14.41 154.48 31.18 157.66 31.18 141.82 14.41 138.65 14.41 154.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "34.7 84.52 34.7 100.09 38.68 100.85 38.68 85.27 34.7 84.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "34.7 103.67 34.7 119.5 38.68 120.26 38.68 104.43 34.7 103.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "34.7 142.49 34.7 158.32 38.68 159.08 38.68 143.24 34.7 142.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "34.7 123.08 34.7 138.91 38.68 139.67 38.68 123.84 34.7 123.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "14.41 193.29 31.18 196.47 31.18 180.64 14.41 177.46 14.41 193.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "34.7 161.9 34.7 177.73 38.68 178.48 38.68 162.65 34.7 161.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "14.41 115.66 31.18 118.84 31.18 103.01 14.41 99.83 14.41 115.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "14.41 173.89 31.18 177.06 31.18 161.23 14.41 158.06 14.41 173.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "11.1 77.1 11.22 76.49 38.68 81.7 38.68 55.16 11.1 60.39 11.1 77.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "14.41 96.25 31.18 99.43 31.18 83.85 14.41 80.67 14.41 96.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "14.41 135.07 31.18 138.25 31.18 122.42 14.41 119.24 14.41 135.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "38.68 201.72 11.1 196.5 11.1 242.89 11.8 243.02 38.68 237.93 38.68 201.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "34.7 181.31 34.7 197.14 38.68 197.89 38.68 182.06 34.7 181.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "11.1 243.16 11.8 243.02 11.1 242.89 11.1 243.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "11.1 243.16 11.8 243.02 11.1 242.89 11.1 243.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M11.1,77.1V196.5l27.58,5.22v-3.83l-4-.75V181.31l4,.75v-3.58l-4-.75V161.9l4,.75v-3.57l-4-.76V142.49l4,.75v-3.57l-4-.76V123.08l4,.76v-3.58l-4-.76V103.67l4,.76v-3.58l-4-.75V84.52l4,.75V81.7L11.22,76.49ZM31.18,196.47l-16.77-3.18V177.46l16.77,3.18Zm0-19.41-16.77-3.17V158.06l16.77,3.17Zm0-19.4-16.77-3.18V138.65l16.77,3.17Zm0-19.41-16.77-3.18V119.24l16.77,3.18Zm0-19.41-16.77-3.18V99.83L31.18,103Zm0-19.41L14.41,96.25V80.67l16.77,3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M11.1,77.1V196.5l27.58,5.22v-3.83l-4-.75V181.31l4,.75v-3.58l-4-.75V161.9l4,.75v-3.57l-4-.76V142.49l4,.75v-3.57l-4-.76V123.08l4,.76v-3.58l-4-.76V103.67l4,.76v-3.58l-4-.75V84.52l4,.75V81.7L11.22,76.49ZM31.18,196.47l-16.77-3.18V177.46l16.77,3.18Zm0-19.41-16.77-3.17V158.06l16.77,3.17Zm0-19.4-16.77-3.18V138.65l16.77,3.17Zm0-19.41-16.77-3.18V119.24l16.77,3.18Zm0-19.41-16.77-3.18V99.83L31.18,103Zm0-19.41L14.41,96.25V80.67l16.77,3.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "77.05 116.46 80.57 117.13 81.98 117.39 94.55 115.01 103.98 113.22 109.56 112.17 103.5 111.02 99.99 110.36 81.98 106.94 80.57 107.21 77.05 107.88 76.41 108 66.97 109.79 57.63 111.56 54.4 112.17 57.63 112.78 77.05 116.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "80.57 151.18 80.57 167.01 81.98 167.28 81.98 151.45 80.57 151.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M70.24,201c.48.25,1.11.36,1,.71s-.82.82-.9,1.12l.16,1.14,6.56,1.24V189.33l-19.42-3.68v7.08l.19-.11c.52-.28,3.68-2,6.76-.5.31.15,2.79,1.36,3.27,3.63a2.57,2.57,0,0,1,0,1.27,24.32,24.32,0,0,1,1.85,3.33C69.75,200.59,69.77,200.7,70.24,201Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "80.57 190 80.57 205.83 81.98 206.1 81.98 190.26 80.57 190"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M70.69,207.79l-1.65.64-.74.29a5.18,5.18,0,0,0-.24,1.45,6,6,0,0,0,.13,1.38,31.09,31.09,0,0,1,10.26,2.73A27.84,27.84,0,0,1,82,216.35v-6.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "80.57 131.77 80.57 147.6 81.98 147.87 81.98 132.04 80.57 131.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "77.05 169.92 57.63 166.24 57.63 182.07 77.05 185.75 77.05 169.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M56,213.13a25,25,0,0,1,3.18-1,12.9,12.9,0,0,1,0-1.88v-.12a7.44,7.44,0,0,1-3.83-2.33,8.07,8.07,0,0,1-.93-1.17v7.39a5.45,5.45,0,0,1,1.51-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M76.53,226.21c0,1.52-1.21,3.32-1.42,3.91-.73,2.1,1.81,11,2.72,14.07L82,245V229.41C79.48,227.43,76.56,225,76.53,226.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "57.63 123.85 77.05 127.53 77.05 116.46 57.63 112.78 57.63 123.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "77.05 131.11 57.63 127.43 57.63 143.26 77.05 146.94 77.05 131.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "77.05 150.51 57.63 146.83 57.63 162.67 77.05 166.35 77.05 150.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "80.57 117.13 80.57 128.19 81.98 128.46 81.98 117.39 80.57 117.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "80.57 170.59 80.57 186.42 81.98 186.69 81.98 170.86 80.57 170.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M57.62,192.74h0v-7.08l19.42,3.68v15.83l-6.56-1.24.52,3.74-.32.13L82,209.93V206.1l-1.41-.27V190l1.41.26v-3.57l-1.41-.27V170.59l1.41.27v-3.58L80.57,167V151.18l1.41.27v-3.58l-1.41-.27V131.77L82,132v-3.58l-1.41-.27V117.13l-3.52-.67v11.07l-19.42-3.68V112.78l-3.23-.61v78.19a3.56,3.56,0,0,1,1.3.33A3.7,3.7,0,0,1,57.62,192.74Zm0-65.31,19.42,3.68v15.83l-19.42-3.68Zm0,19.4,19.42,3.68v15.84l-19.42-3.68Zm0,19.41,19.42,3.68v15.83l-19.42-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M57.62,192.74h0v-7.08l19.42,3.68v15.83l-6.56-1.24.52,3.74-.32.13L82,209.93V206.1l-1.41-.27V190l1.41.26v-3.57l-1.41-.27V170.59l1.41.27v-3.58L80.57,167V151.18l1.41.27v-3.58l-1.41-.27V131.77L82,132v-3.58l-1.41-.27V117.13l-3.52-.67v11.07l-19.42-3.68V112.78l-3.23-.61v78.19a3.56,3.56,0,0,1,1.3.33A3.7,3.7,0,0,1,57.62,192.74Zm0-65.31,19.42,3.68v15.83l-19.42-3.68Zm0,19.4,19.42,3.68v15.84l-19.42-3.68Zm0,19.41,19.42,3.68v15.83l-19.42-3.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "103.5 116.71 103.5 132.54 109.56 133.69 109.56 117.86 103.5 116.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M91.17,235.17a6.29,6.29,0,0,1-1.76-.25q-3.34-2.31-6.9-5.08l-.53-.43V245l27.58-5.22V227.26l-1.54,1C98.24,234.62,94,235.34,91.17,235.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "103.5 155.53 103.5 171.36 109.56 172.5 109.56 156.67 103.5 155.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "109.56 114.28 109.56 112.17 103.98 113.22 109.56 114.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "99.99 116.04 94.55 115.01 81.98 117.39 81.98 128.46 99.99 131.88 99.99 116.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "103.5 136.12 103.5 151.95 109.56 153.1 109.56 137.26 103.5 136.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "99.99 154.86 81.98 151.45 81.98 167.28 99.99 170.69 99.99 154.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "99.99 193.68 81.98 190.26 81.98 206.1 99.99 209.51 99.99 193.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M91.25,215.61a.84.84,0,0,1,.19.15l.27-.08,6.77-1.06a1.86,1.86,0,0,1-.46.76,1.8,1.8,0,0,1-1,.51l-1.36.42-.15,1.24a1.33,1.33,0,0,1-.52.92,3.72,3.72,0,0,1-.73.6,3.43,3.43,0,0,1-.86,0l-.7.29a.75.75,0,0,1-.67.09.81.81,0,0,1-.49-.48l-.3-.16a2,2,0,0,1-.39.26,25.06,25.06,0,0,1-3.72,1.57,43.38,43.38,0,0,1,5.36,6.09c3-.72,6.27-1.65,9.72-2.85.71-.24,1.4-.49,2.08-.75l-3.78-1.08a.91.91,0,0,1-.62-1.12l2.08-7.21-20-3.79v6.42l.1.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "99.99 174.27 81.98 170.86 81.98 186.69 99.99 190.1 99.99 174.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "99.99 135.45 81.98 132.04 81.98 147.87 99.99 151.28 99.99 135.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "103.5 174.94 103.5 190.77 109.56 191.91 109.56 176.08 103.5 174.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M104.64,207.36l4.92.56V195.49l-6.06-1.15V208.6l.17-.59A.91.91,0,0,1,104.64,207.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "94.55 115.01 99.99 116.04 99.99 131.88 81.98 128.46 81.98 132.04 99.99 135.45 99.99 151.28 81.98 147.87 81.98 151.45 99.99 154.86 99.99 170.69 81.98 167.28 81.98 170.86 99.99 174.27 99.99 190.1 81.98 186.69 81.98 190.26 99.99 193.68 99.99 209.51 81.98 206.1 81.98 209.93 102.02 213.72 103.5 208.6 103.5 194.34 109.56 195.49 109.56 191.91 103.5 190.77 103.5 174.94 109.56 176.08 109.56 172.5 103.5 171.36 103.5 155.53 109.56 156.67 109.56 153.1 103.5 151.95 103.5 136.12 109.56 137.26 109.56 133.69 103.5 132.54 103.5 116.71 109.56 117.86 109.56 114.28 103.98 113.22 94.55 115.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "94.55 115.01 99.99 116.04 99.99 131.88 81.98 128.46 81.98 132.04 99.99 135.45 99.99 151.28 81.98 147.87 81.98 151.45 99.99 154.86 99.99 170.69 81.98 167.28 81.98 170.86 99.99 174.27 99.99 190.1 81.98 186.69 81.98 190.26 99.99 193.68 99.99 209.51 81.98 206.1 81.98 209.93 102.02 213.72 103.5 208.6 103.5 194.34 109.56 195.49 109.56 191.91 103.5 190.77 103.5 174.94 109.56 176.08 109.56 172.5 103.5 171.36 103.5 155.53 109.56 156.67 109.56 153.1 103.5 151.95 103.5 136.12 109.56 137.26 109.56 133.69 103.5 132.54 103.5 116.71 109.56 117.86 109.56 114.28 103.98 113.22 94.55 115.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M480.55,387.58v4.32H478.6v-4.7l-32.39-6.33h0l-3.41-.66-.19-.06-.24.29c-2.84,3.49-5.57,8.23-8.57,11.9-5.61,3.4-10.15,7-16.43,9.36l-.11,0c-1.77,1.18-3.58,1.66-5.07,2.82a9.87,9.87,0,0,0-1.51,1.64,6.76,6.76,0,0,0-.47.84l2.19.43-.38,1.92-2.63-.51a12.72,12.72,0,0,0-.24,1.76c0,.26,0,.55.08.89.3,2.89.81,6,1.46,9.11.09.24.18.49.28.73h-.13c1.05,5,2.45,10.22,4,15.43l73.34,13.89V389.07Zm-58,23.88-5.76-1.13.37-1.92,5.77,1.13Zm10.57,2.06-5.76-1.12.37-1.92,5.77,1.12Zm10.57,2.07L438,414.46l.37-1.92,5.77,1.13Zm10.57,2.06-5.76-1.12.37-1.92,5.77,1.12Zm10.57,2.07-5.76-1.13.37-1.92,5.77,1.13Zm11.38,2.14h0a4.4,4.4,0,0,1-.8-.07l-5.76-1.13.37-1.92,5.77,1.12a2.09,2.09,0,0,0,.42.05h0A2.37,2.37,0,0,0,478.4,418l1.87.58A4.3,4.3,0,0,1,476.25,421.86Zm4.3-8.42H478.6v-5.88h1.95Zm0-10.77H478.6v-5.88h1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M390.89,411.52c-.33-.92-.69-1.83-1.07-2.74l-1.41,2.06-.06.08h0c-.61.89-1.23,1.77-1.88,2.65a10,10,0,0,0-1.56,3,4.61,4.61,0,0,0-.25,1.26c0,1,.06,1.72,0,2.84-.08,3.47-.49,6.77-.91,10.23l7.54,1.43C391.68,425.25,392,419.18,390.89,411.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M359.09,429.91h0l9.67-1.83,11,2.07c0-4.23-.07-8.46-.09-12.65a6.4,6.4,0,0,1,.09-1c.06-.37.21-.64.29-1a43.82,43.82,0,0,1,2.81-8.32h0l0-.06a42.54,42.54,0,0,1,2.63-4.75l0-.14h.06c.13-.21.26-.42.4-.63h0a14.55,14.55,0,0,1,4.12-3.5c-1.09-.68-2.65-2-2.78-3.42a6.16,6.16,0,0,1,.3-3.13c-.76-2.69-1.2-3.79-.45-7.09.22-1,1.82-4.48,3.69-5.41a12.83,12.83,0,0,1,4.7-1.38c2.13-1.2,5,.62,6.59,1.59,1.79,1.1,2.25,2.84,2.89,4.54,2.11,1.84,3.32,2.72,3.36,6.32,0,.2-1.74,3.69-2.9,4.54-.79.57-2.8.66-4.42.6a7.11,7.11,0,0,0,.47.74c1.45,0,2.87-.07,4.22-.16a45.94,45.94,0,0,0,9-1.77l.06.16.65-.23c2.57-1,4.7-2.35,7.42-3.38,1.44-.54,3.58-1.25,5.2-1.68a27.72,27.72,0,0,1,4.33-6.37c2.51-3,4.8-4.36,7.88-6.58l.11-.08V351.17L373,338h0l-3.42-.67a3.45,3.45,0,0,1-2.36-3.42V286.43c0-1.63,1.06-2.75,2.36-2.49l106.81,20.87c1.74.34,3.16,2.38,3.16,4.56V334l8.6,1.68V238.42c0-2.17-1.42-4.21-3.16-4.55L361.8,209.79c-1.74-.34-3.15,1.14-3.15,3.32v58l9,1.7a3.9,3.9,0,0,1-.38-1.67V223.65c0-1.63,1.06-2.75,2.36-2.49L476.42,242c1.74.34,3.16,2.38,3.16,4.56V292.1a4.09,4.09,0,0,1-.42,1.84l.2,0a1.76,1.76,0,0,1-.32,3.49l-.33,0L358.65,274.68V407.05l10.1,21ZM432.37,358l5.77,1.13-.38,1.92L432,359.9Zm-10.57-2.07,5.77,1.13-.38,1.92-5.76-1.12Zm-10.57-2.06L417,355l-.38,1.92-5.76-1.13Zm-10.57-2.07,5.77,1.13-.38,1.92-5.76-1.12Zm-10.57-2.06,5.77,1.12-.38,1.93-5.76-1.13Zm-10.57-2.07,5.77,1.13-.38,1.92-5.76-1.13Zm1.17,53.62-.38,1.93-5.76-1.13.37-1.92Zm-9.31-55.21,3.34.65-.38,1.93L371,348a2,2,0,0,0-1.59.34l-1.15-1.58A4,4,0,0,1,371.38,346.06Zm-5.11,5.88h2v5.87h-2Zm0,10.77h2v5.87h-2Zm0,10.77h2v5.87h-2Zm0,10.77h2v5.87h-2Zm0,10.81,2-.09a5.15,5.15,0,0,0,2.27,4.14l-1,1.69A7.1,7.1,0,0,1,366.28,395.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M361.8,432.4l18,3.51c0-1.92,0-3.84,0-5.76l-11-2.07-9.67,1.83A4,4,0,0,0,361.8,432.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M361.8,432.4l18,3.51c0-1.92,0-3.84,0-5.76l-11-2.07-9.67,1.83A4,4,0,0,0,361.8,432.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M416.78,443.14,485,456.48c1.74.34,3.16-1.15,3.16-3.32V450.7l-73.34-13.89C415.47,438.93,416.12,441.05,416.78,443.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M416.78,443.14,485,456.48c1.74.34,3.16-1.15,3.16-3.32V450.7l-73.34-13.89C415.47,438.93,416.12,441.05,416.78,443.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M391.33,432.35l-7.54-1.43c-.17,1.4-.34,2.81-.5,4.28,0,.3-.07.8-.12,1.38l7.91,1.54C391.15,436.1,391.24,434.19,391.33,432.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M391.33,432.35l-7.54-1.43c-.17,1.4-.34,2.81-.5,4.28,0,.3-.07.8-.12,1.38l7.91,1.54C391.15,436.1,391.24,434.19,391.33,432.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M359.09,429.91l9.66-1.83-10.1-21v20.79A5.16,5.16,0,0,0,359.09,429.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M359.09,429.91l9.66-1.83-10.1-21v20.79A5.16,5.16,0,0,0,359.09,429.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M479,297.46a1.76,1.76,0,0,0,.32-3.49l-.2,0a2.48,2.48,0,0,1-2.74,1.48L369.61,274.55a3,3,0,0,1-2-1.75l-9-1.7v3.58l120.06,22.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M479,297.46a1.76,1.76,0,0,0,.32-3.49l-.2,0a2.48,2.48,0,0,1-2.74,1.48L369.61,274.55a3,3,0,0,1-2-1.75l-9-1.7v3.58l120.06,22.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 418.92,
    y: 407,
    width: 1.96,
    height: 5.87,
    transform: "translate(-62.93 743.46) rotate(-78.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 381.24,
    y: 346.24,
    width: 1.96,
    height: 5.87,
    transform: "translate(-33.75 657.37) rotate(-78.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M385.49,402.21l0,.14.08-.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 478.6,
    y: 396.79,
    width: 1.96,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 366.27,
    y: 373.48,
    width: 1.96,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 391.81,
    y: 348.3,
    width: 1.96,
    height: 5.87,
    transform: "translate(-27.23 669.43) rotate(-78.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 461.2,
    y: 415.26,
    width: 1.96,
    height: 5.87,
    transform: "translate(-36.91 791.57) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 450.63,
    y: 413.19,
    width: 1.96,
    height: 5.87,
    transform: "matrix(0.19, -0.98, 0.98, 0.19, -43.44, 779.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 440.06,
    y: 411.13,
    width: 1.96,
    height: 5.87,
    transform: "translate(-49.94 767.48) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M476.25,419.91h0a2.09,2.09,0,0,1-.42-.05l-5.77-1.12-.37,1.92,5.76,1.13a4.4,4.4,0,0,0,.8.07h0a4.3,4.3,0,0,0,4-3.26L478.4,418A2.37,2.37,0,0,1,476.25,419.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M371,348l3.33.66.38-1.93-3.34-.65a4,4,0,0,0-3.11.68l1.15,1.58A2,2,0,0,1,371,348Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 478.6,
    y: 407.56,
    width: 1.96,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 366.27,
    y: 384.25,
    width: 1.96,
    height: 5.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M412,409.39l.38-1.92-2.19-.43c-.09.19-.18.37-.26.57a2.16,2.16,0,0,1-.38.62,6.16,6.16,0,0,0-.18.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 412.95,
    y: 352.44,
    width: 1.96,
    height: 5.87,
    transform: "matrix(0.19, -0.98, 0.98, 0.19, -14.26, 693.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M370.5,399.11a5.15,5.15,0,0,1-2.27-4.14l-2,.09a7.1,7.1,0,0,0,3.23,5.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 402.38,
    y: 350.37,
    width: 1.96,
    height: 5.87,
    transform: "translate(-20.71 681.47) rotate(-78.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 434.09,
    y: 356.57,
    width: 1.96,
    height: 5.87,
    transform: "translate(-1.22 717.53) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 423.52,
    y: 354.5,
    width: 1.96,
    height: 5.87,
    transform: "translate(-7.73 705.48) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 429.49,
    y: 409.06,
    width: 1.96,
    height: 5.87,
    transform: "translate(-56.46 755.44) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 376.64,
    y: 398.73,
    width: 1.96,
    height: 5.87,
    transform: "translate(-88.94 695.38) rotate(-78.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 366.27,
    y: 362.71,
    width: 1.96,
    height: 5.87
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "478.6 391.9 480.56 391.9 480.56 387.58 478.6 387.2 478.6 391.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 366.27,
    y: 351.94,
    width: 1.96,
    height: 5.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M442.8,326.81,479.58,334V309.37c0-2.18-1.42-4.22-3.16-4.56L369.61,283.94l3.42.66V338l67.4,13.17V329.31C440.43,327.67,441.49,326.56,442.8,326.81Zm19.71-15.73c0-1.63,1.06-2.75,2.37-2.5l7,1.38a3.42,3.42,0,0,1,2.37,3.41v8.76c0,1.64-1.06,2.75-2.37,2.5l-7-1.37a3.44,3.44,0,0,1-2.37-3.42Zm-50.25,27.48-31-6.06.37-1.92,31,6.06Zm13.87-19.95-44.86-8.76.37-1.93,44.87,8.77ZM435,313l-53.74-10.5.37-1.92,53.74,10.5Zm0-7.33-53.74-10.51.37-1.92,53.74,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M464.88,323.26l7,1.37c1.31.25,2.37-.86,2.37-2.5v-8.76A3.42,3.42,0,0,0,471.9,310l-7-1.38c-1.31-.25-2.37.87-2.37,2.5v8.76A3.44,3.44,0,0,0,464.88,323.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M369.61,283.94c-1.3-.26-2.36.86-2.36,2.49v47.48a3.45,3.45,0,0,0,2.36,3.42L373,338h0V284.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 407.35,
    y: 272.09,
    width: 1.96,
    height: 54.76,
    transform: "translate(36.11 642.77) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 407.35,
    y: 279.42,
    width: 1.96,
    height: 54.76,
    transform: "translate(28.91 648.71) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 402.91,
    y: 290.41,
    width: 1.96,
    height: 45.71,
    transform: "translate(18.97 649.58) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 395.98,
    y: 318.78,
    width: 1.96,
    height: 31.58,
    transform: "translate(-7.54 659.98) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M373,275.22l-3.42-.67,106.81,20.87a2.48,2.48,0,0,0,2.74-1.48,4.09,4.09,0,0,0,.42-1.84V246.59c0-2.18-1.42-4.22-3.16-4.56L369.61,221.16l3.42.67Zm89.48-26.92c0-1.63,1.06-2.75,2.37-2.49l7,1.37a3.43,3.43,0,0,1,2.37,3.42v8.76c0,1.63-1.06,2.74-2.37,2.49l-7-1.37a3.44,3.44,0,0,1-2.37-3.42Zm-80.87-17.82L435.38,241,435,242.9l-53.74-10.5Zm0,7.33,53.74,10.5-.37,1.92-53.74-10.5Zm0,7.34,44.87,8.76-.38,1.93-44.86-8.77Zm0,22.65,31,6.06-.38,1.92-31-6.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M464.88,260.48l7,1.37c1.31.25,2.37-.86,2.37-2.49V250.6a3.43,3.43,0,0,0-2.37-3.42l-7-1.37c-1.31-.26-2.37.86-2.37,2.49v8.76A3.44,3.44,0,0,0,464.88,260.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M369.61,274.55l3.42.67V221.83l-3.42-.67c-1.3-.26-2.36.86-2.36,2.49v47.48a3.9,3.9,0,0,0,.38,1.67A3,3,0,0,0,369.61,274.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 407.35,
    y: 209.31,
    width: 1.96,
    height: 54.76,
    transform: "translate(97.73 592.04) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 407.35,
    y: 216.64,
    width: 1.96,
    height: 54.76,
    transform: "translate(90.52 597.97) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 402.91,
    y: 227.63,
    width: 1.96,
    height: 45.71,
    transform: "translate(80.59 598.84) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 395.98,
    y: 256,
    width: 1.96,
    height: 31.58,
    transform: "translate(54.08 609.25) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M506.76,311.55c0-1.64,1.06-2.75,2.37-2.5l106.8,20.87c1.75.34,3.16,2.39,3.16,4.56V380c0,2.18-1.41,3.67-3.16,3.33L552.76,371v26.78c0,2.18-1.41,3.67-3.16,3.33L498.16,391v61.57l129.53,24.55V263.77c0-2.2-1.41-4.25-3.16-4.6L501.32,234.9c-1.75-.34-3.16,1.16-3.16,3.35v99.38l8.6,1.68Zm93.7,103.72c0,1.63-1.06,2.75-2.36,2.49l-7-1.37a3.43,3.43,0,0,1-2.37-3.42v-8.76c0-1.63,1.06-2.75,2.37-2.49l7,1.37a3.45,3.45,0,0,1,2.36,3.42Zm-93.7-166.5c0-1.63,1.06-2.75,2.37-2.5l106.8,20.88c1.75.34,3.16,2.38,3.16,4.55v45.52c0,2.17-1.41,3.66-3.16,3.32l-106.8-20.87a3.44,3.44,0,0,1-2.37-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M498.16,454.68c0,2.19,1.41,4.25,3.16,4.59l123.21,24.27c1.75.35,3.16-1.15,3.16-3.35v-3.05L498.16,452.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M498.16,454.68c0,2.19,1.41,4.25,3.16,4.59l123.21,24.27c1.75.35,3.16-1.15,3.16-3.35v-3.05L498.16,452.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M512.54,340.44l37.06,7.24c1.75.35,3.16,2.39,3.16,4.56V371l63.17,12.35c1.75.34,3.16-1.15,3.16-3.33V334.48c0-2.17-1.41-4.22-3.16-4.56l-106.8-20.87,3.41.67Zm76.17,2.74c0-1.63,1.06-2.75,2.37-2.49l7,1.37a3.44,3.44,0,0,1,2.36,3.42v8.76c0,1.63-1.06,2.75-2.36,2.49l-7-1.37a3.44,3.44,0,0,1-2.37-3.42Zm-67.55-24.81,53.74,10.5-.38,1.92-53.74-10.5Zm0,7.33,53.74,10.51-.38,1.92-53.74-10.5Zm0,7.34L566,341.81l-.37,1.92L520.78,335Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M512.54,340.44l37.06,7.24c1.75.35,3.16,2.39,3.16,4.56V371l63.17,12.35c1.75.34,3.16-1.15,3.16-3.33V334.48c0-2.17-1.41-4.22-3.16-4.56l-106.8-20.87,3.41.67Zm76.17,2.74c0-1.63,1.06-2.75,2.37-2.49l7,1.37a3.44,3.44,0,0,1,2.36,3.42v8.76c0,1.63-1.06,2.75-2.36,2.49l-7-1.37a3.44,3.44,0,0,1-2.37-3.42Zm-67.55-24.81,53.74,10.5-.38,1.92-53.74-10.5Zm0,7.33,53.74,10.51-.38,1.92-53.74-10.5Zm0,7.34L566,341.81l-.37,1.92L520.78,335Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M512.54,309.72l-3.41-.67c-1.31-.25-2.37.86-2.37,2.5v27.76l5.78,1.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 546.86,
    y: 297.2,
    width: 1.96,
    height: 54.76,
    transform: "translate(124.21 800) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 546.86,
    y: 304.54,
    width: 1.96,
    height: 54.76,
    transform: "translate(117.02 805.93) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 542.42,
    y: 315.53,
    width: 1.96,
    height: 45.71,
    transform: "translate(107.08 806.8) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M512.54,300.34l-3.41-.67,106.8,20.87c1.75.34,3.16-1.15,3.16-3.32V271.7c0-2.17-1.41-4.21-3.16-4.55l-106.8-20.88,3.41.67Zm8.62-44.75,53.74,10.5-.38,1.92-53.74-10.5Zm0,7.34,53.74,10.5-.38,1.92-53.74-10.5Zm0,7.33L566,279l-.37,1.92-44.87-8.77Zm0,22.66,31,6.05-.37,1.93-31-6.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M512.54,300.34l-3.41-.67,106.8,20.87c1.75.34,3.16-1.15,3.16-3.32V271.7c0-2.17-1.41-4.21-3.16-4.55l-106.8-20.88,3.41.67Zm8.62-44.75,53.74,10.5-.38,1.92-53.74-10.5Zm0,7.34,53.74,10.5-.38,1.92-53.74-10.5Zm0,7.33L566,279l-.37,1.92-44.87-8.77Zm0,22.66,31,6.05-.37,1.93-31-6.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M509.13,299.67l3.41.67v-53.4l-3.41-.67c-1.31-.25-2.37.87-2.37,2.5v47.48A3.44,3.44,0,0,0,509.13,299.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 546.86,
    y: 234.42,
    width: 1.96,
    height: 54.76,
    transform: "translate(185.83 749.27) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 546.86,
    y: 241.76,
    width: 1.96,
    height: 54.76,
    transform: "translate(178.63 755.19) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 542.42,
    y: 252.75,
    width: 1.96,
    height: 45.71,
    transform: "translate(168.69 756.06) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 535.49,
    y: 281.12,
    width: 1.96,
    height: 31.58,
    transform: "translate(142.19 766.48) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "498.16 344.6 498.16 337.63 488.18 335.68 488.18 342.64 498.16 344.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "488.18 359.31 488.18 389.07 498.16 391.02 498.16 361.26 488.18 359.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "498.16 351.93 498.16 346.59 488.18 344.64 488.18 349.98 498.16 351.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "488.18 357.32 498.16 359.27 498.16 353.93 488.18 351.98 488.18 357.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "488.18 344.64 479.58 342.96 479.58 348.3 488.18 349.98 488.18 344.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "488.18 344.64 479.58 342.96 479.58 348.3 488.18 349.98 488.18 344.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M488.18,352l-8.6-1.68v4.58a4.32,4.32,0,0,1-.07.74l8.67,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M488.18,352l-8.6-1.68v4.58a4.32,4.32,0,0,1-.07.74l8.67,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M478.6,387.2V386h1.95v1.56l7.63,1.49V359.31l-9.51-1.86a2.37,2.37,0,0,1-2.25.75l-30.21-5.9v8.39l2.5.48-.38,1.92-2.12-.41v6.26c.81-.72,1.76-1.44,2.35-2,.38-.38,1.5-1.8,1.92-1.69s0,.73-.07.86c-.3.91-1.62,1.9-1.52,2.86,0,.3.3.25.49.67a2.61,2.61,0,0,1,.48,1.2,3.76,3.76,0,0,1-.59,2,4.27,4.27,0,0,1-1.34,1.64,5.42,5.42,0,0,1-1.08.53l-.64.81v5.13Zm7.23-7.69-.38,1.92-4.9-.95v.65H478.6v-1l-24.14-4.71.37-1.93,23.77,4.65v-2.85h1.95v3.23Zm-11.18-13.27,1.17.23a6,6,0,0,1,4.07,3.57l-1.79.8a4.06,4.06,0,0,0-2.66-2.45l-1.16-.23Zm-10.57-2.06,5.77,1.12-.38,1.93-5.76-1.13Zm-10.57-2.07,5.77,1.13-.38,1.92L453.14,364Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M478.6,387.2V386h1.95v1.56l7.63,1.49V359.31l-9.51-1.86a2.37,2.37,0,0,1-2.25.75l-30.21-5.9v8.39l2.5.48-.38,1.92-2.12-.41v6.26c.81-.72,1.76-1.44,2.35-2,.38-.38,1.5-1.8,1.92-1.69s0,.73-.07.86c-.3.91-1.62,1.9-1.52,2.86,0,.3.3.25.49.67a2.61,2.61,0,0,1,.48,1.2,3.76,3.76,0,0,1-.59,2,4.27,4.27,0,0,1-1.34,1.64,5.42,5.42,0,0,1-1.08.53l-.64.81v5.13Zm7.23-7.69-.38,1.92-4.9-.95v.65H478.6v-1l-24.14-4.71.37-1.93,23.77,4.65v-2.85h1.95v3.23Zm-11.18-13.27,1.17.23a6,6,0,0,1,4.07,3.57l-1.79.8a4.06,4.06,0,0,0-2.66-2.45l-1.16-.23Zm-10.57-2.06,5.77,1.12-.38,1.93-5.76-1.13Zm-10.57-2.07,5.77,1.13-.38,1.92L453.14,364Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "479.58 340.96 488.18 342.64 488.18 335.68 479.58 334 479.58 340.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "479.58 340.96 488.18 342.64 488.18 335.68 479.58 334 479.58 340.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M478.1,370.84l1.79-.8a6,6,0,0,0-4.07-3.57l-1.17-.23-.37,1.92,1.16.23A4.06,4.06,0,0,1,478.1,370.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M478.1,370.84l1.79-.8a6,6,0,0,0-4.07-3.57l-1.17-.23-.37,1.92,1.16.23A4.06,4.06,0,0,1,478.1,370.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "478.6 381.13 480.56 381.13 480.56 380.48 478.6 380.09 478.6 381.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "478.6 381.13 480.56 381.13 480.56 380.48 478.6 380.09 478.6 381.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 465.8,
    y: 362.76,
    width: 1.96,
    height: 5.87,
    transform: "translate(18.32 753.65) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 465.8,
    y: 362.76,
    width: 1.96,
    height: 5.87,
    transform: "translate(18.32 753.65) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 455.23,
    y: 360.7,
    width: 1.96,
    height: 5.87,
    transform: "translate(11.81 741.61) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 455.23,
    y: 360.7,
    width: 1.96,
    height: 5.87,
    transform: "translate(11.81 741.61) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "478.6 375.25 478.6 378.1 480.56 378.48 480.56 375.25 478.6 375.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "478.6 375.25 478.6 378.1 480.56 378.48 480.56 375.25 478.6 375.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "448.71 361.17 446.21 360.69 446.21 362.68 448.33 363.09 448.71 361.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "448.71 361.17 446.21 360.69 446.21 362.68 448.33 363.09 448.71 361.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "478.6 386.02 478.6 387.2 480.56 387.58 480.56 386.02 478.6 386.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "478.6 386.02 478.6 387.2 480.56 387.58 480.56 386.02 478.6 386.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M446.21,327.48V352.3l30.21,5.9a2.37,2.37,0,0,0,2.25-.75l-24.21-4.73.37-1.92,24.68,4.82a4.32,4.32,0,0,0,.07-.74V350.3l-25.12-4.91.37-1.93,24.75,4.84V343l-25.12-4.91.37-1.92L479.58,341v-7l-36.78-7.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M446.21,327.48V352.3l30.21,5.9a2.37,2.37,0,0,0,2.25-.75l-24.21-4.73.37-1.92,24.68,4.82a4.32,4.32,0,0,0,.07-.74V350.3l-25.12-4.91.37-1.93,24.75,4.84V343l-25.12-4.91.37-1.92L479.58,341v-7l-36.78-7.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M512.54,363.11l-3.41-.66a3.44,3.44,0,0,1-2.37-3.42v-3.42l-8.6-1.68v5.34l1.54.3-.38,1.92-1.16-.23V391l51.44,10.06c1.75.34,3.16-1.15,3.16-3.33V371l-40.22-7.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M512.54,363.11l-3.41-.66a3.44,3.44,0,0,1-2.37-3.42v-3.42l-8.6-1.68v5.34l1.54.3-.38,1.92-1.16-.23V391l51.44,10.06c1.75.34,3.16-1.15,3.16-3.33V371l-40.22-7.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "506.76 353.61 506.76 348.27 498.16 346.59 498.16 351.93 506.76 353.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "506.76 353.61 506.76 348.27 498.16 346.59 498.16 351.93 506.76 353.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "506.76 346.28 506.76 339.31 498.16 337.63 498.16 344.6 506.76 346.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "506.76 346.28 506.76 339.31 498.16 337.63 498.16 344.6 506.76 346.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M549.6,347.68l-37.06-7.24v22.67L552.76,371V352.24C552.76,350.07,551.35,348,549.6,347.68ZM547.45,365c0,1.63-1.06,2.75-2.37,2.49l-7-1.37a3.43,3.43,0,0,1-2.37-3.42v-2.18l-14.92-2.91.38-1.93,14.54,2.85V354c0-1.63,1.06-2.74,2.37-2.49l7,1.37a3.44,3.44,0,0,1,2.37,3.42v4.58l4.7.92-.37,1.92-4.33-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M549.6,347.68l-37.06-7.24v22.67L552.76,371V352.24C552.76,350.07,551.35,348,549.6,347.68ZM547.45,365c0,1.63-1.06,2.75-2.37,2.49l-7-1.37a3.43,3.43,0,0,1-2.37-3.42v-2.18l-14.92-2.91.38-1.93,14.54,2.85V354c0-1.63,1.06-2.74,2.37-2.49l7,1.37a3.44,3.44,0,0,1,2.37,3.42v4.58l4.7.92-.37,1.92-4.33-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M549.6,347.68l-37.06-7.24v22.67L552.76,371V352.24C552.76,350.07,551.35,348,549.6,347.68ZM547.45,365c0,1.63-1.06,2.75-2.37,2.49l-7-1.37a3.43,3.43,0,0,1-2.37-3.42v-2.18l-14.92-2.91.38-1.93,14.54,2.85V354c0-1.63,1.06-2.74,2.37-2.49l7,1.37a3.44,3.44,0,0,1,2.37,3.42v4.58l4.7.92-.37,1.92-4.33-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M508.2,348.55l-1.44-.28v5.34l1.81.36-.37,1.92-1.44-.28V359a3.44,3.44,0,0,0,2.37,3.42l3.41.66h0V340.44l-5.78-1.13v7l1.81.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M508.2,348.55l-1.44-.28v5.34l1.81.36-.37,1.92-1.44-.28V359a3.44,3.44,0,0,0,2.37,3.42l3.41.66h0V340.44l-5.78-1.13v7l1.81.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "521.16 355.69 520.78 357.62 535.7 360.53 535.7 358.54 521.16 355.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "521.16 355.69 520.78 357.62 535.7 360.53 535.7 358.54 521.16 355.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "552.15 361.75 547.45 360.83 547.45 362.83 551.78 363.67 552.15 361.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "552.15 361.75 547.45 360.83 547.45 362.83 551.78 363.67 552.15 361.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M547.45,356.25a3.44,3.44,0,0,0-2.37-3.42l-7-1.37c-1.31-.25-2.37.86-2.37,2.49v8.76a3.43,3.43,0,0,0,2.37,3.42l7,1.37c1.31.26,2.37-.86,2.37-2.49v-8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M446.21,380.87h0v-5.13c-1.2,1.52-2.16,2.64-3.6,4.41l.19.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M443.74,373l0,0c.52-.91.52-1.63,1.2-2.71a6.88,6.88,0,0,1,1.25-1.35V327.48l-3.41-.67c-1.31-.25-2.37.86-2.37,2.5V375.9a26.17,26.17,0,0,0,3.31-2.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "454.46 338.05 479.58 342.96 488.18 344.64 498.16 346.59 506.76 348.27 508.19 348.55 508.57 346.63 506.76 346.28 498.16 344.6 488.18 342.64 479.58 340.96 454.83 336.13 454.46 338.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "498.16 353.93 506.76 355.61 508.19 355.89 508.57 353.97 506.76 353.61 498.16 351.93 488.18 349.98 479.58 348.3 454.83 343.46 454.46 345.39 479.58 350.3 488.18 351.98 498.16 353.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "498.16 361.26 499.32 361.49 499.7 359.57 498.16 359.27 488.18 357.32 479.51 355.62 454.83 350.8 454.46 352.72 478.67 357.45 488.18 359.31 498.16 361.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "454.83 373.45 454.46 375.38 478.6 380.09 480.56 380.48 485.45 381.43 485.83 379.51 480.56 378.48 478.6 378.1 454.83 373.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M91.29,218.81l.3.16a.81.81,0,0,0,.49.48.75.75,0,0,0,.67-.09l.7-.29a3.43,3.43,0,0,0,.86,0,3.72,3.72,0,0,0,.73-.6,1.33,1.33,0,0,0,.52-.92l.15-1.24,1.36-.42a1.8,1.8,0,0,0,1-.51,1.86,1.86,0,0,0,.46-.76l-6.77,1.06-.27.08a1.91,1.91,0,0,1,.66,1.13A2.06,2.06,0,0,1,91.29,218.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M115,209.6a.9.9,0,0,0-.76-1.14l-4.67-.54-4.92-.56a.91.91,0,0,0-1,.65l-.17.59L102,213.72l-2.08,7.21a.91.91,0,0,0,.62,1.12l3.78,1.08,1.39-.53-4.92-1.42,3.73-12.92,9.58,1.09L112.2,216a2.86,2.86,0,0,1-.06.76,6.57,6.57,0,0,0-.09,1.3,3.27,3.27,0,0,0,.24-.27c.22-.28.38-.52.49-.69.18-.75.36-1.5.55-2.25a1.76,1.76,0,0,0,.09.2l.75-2.61.07-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M110.05,220.81l.06.07V219a4,4,0,0,1,.45-1.86,4.25,4.25,0,0,0,.58-1c.31-.74.32-1.29.52-1.31s.42.56.43.59a2,2,0,0,1,.1.56l1.92-6.66-9.58-1.09-3.73,12.92,4.92,1.42C107.24,222,108.69,221.41,110.05,220.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M90.72,317.85l4,1c.2.5-.25,1-.88,1H83.73l-1.06-.58-.66.61-4,0c0-.41,0-1-.07-1.81a32.39,32.39,0,0,0-1.67-7.72c-4.28-.31-9-.48-13.86-.48h0a5.69,5.69,0,0,0,1,1.37,7.34,7.34,0,0,0,4.1,1.91A1.46,1.46,0,0,1,69,314.3a1.11,1.11,0,0,1-.21.74l-7.65.36-1.42-.72-.33.84a11.43,11.43,0,0,1-3.12,0,11.71,11.71,0,0,1-1.55-.32c.05-.6.11-1.49.12-2.55s0-1.76-.09-2.58c-16.71.64-29.26,3.32-29.26,6.53,0,3.69,16.54,6.68,36.93,6.68s36.94-3,36.94-6.68c0-2.26-6.23-4.26-15.74-5.46a10.9,10.9,0,0,0,2.36,3.9A10.56,10.56,0,0,0,90.72,317.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M90.72,317.85l4,1c.2.5-.25,1-.88,1H83.73l-1.06-.58-.66.61-4,0c0-.41,0-1-.07-1.81a32.39,32.39,0,0,0-1.67-7.72c-4.28-.31-9-.48-13.86-.48h0a5.69,5.69,0,0,0,1,1.37,7.34,7.34,0,0,0,4.1,1.91A1.46,1.46,0,0,1,69,314.3a1.11,1.11,0,0,1-.21.74l-7.65.36-1.42-.72-.33.84a11.43,11.43,0,0,1-3.12,0,11.71,11.71,0,0,1-1.55-.32c.05-.6.11-1.49.12-2.55s0-1.76-.09-2.58c-16.71.64-29.26,3.32-29.26,6.53,0,3.69,16.54,6.68,36.93,6.68s36.94-3,36.94-6.68c0-2.26-6.23-4.26-15.74-5.46a10.9,10.9,0,0,0,2.36,3.9A10.56,10.56,0,0,0,90.72,317.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M90.72,317.85l4,1c.2.5-.25,1-.88,1H83.73l-1.06-.58-.66.61-4,0c0-.41,0-1-.07-1.81a32.39,32.39,0,0,0-1.67-7.72c-4.28-.31-9-.48-13.86-.48h0a5.69,5.69,0,0,0,1,1.37,7.34,7.34,0,0,0,4.1,1.91A1.46,1.46,0,0,1,69,314.3a1.11,1.11,0,0,1-.21.74l-7.65.36-1.42-.72-.33.84a11.43,11.43,0,0,1-3.12,0,11.71,11.71,0,0,1-1.55-.32c.05-.6.11-1.49.12-2.55s0-1.76-.09-2.58c-16.71.64-29.26,3.32-29.26,6.53,0,3.69,16.54,6.68,36.93,6.68s36.94-3,36.94-6.68c0-2.26-6.23-4.26-15.74-5.46a10.9,10.9,0,0,0,2.36,3.9A10.56,10.56,0,0,0,90.72,317.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M112.1,215.45s-.22-.61-.43-.59-.21.57-.52,1.31a4.25,4.25,0,0,1-.58,1,4,4,0,0,0-.45,1.86v1.83a4.7,4.7,0,0,1,.64-1.49c.24-.36.72-.64,1.29-1.3a6.57,6.57,0,0,1,.09-1.3,2.86,2.86,0,0,0,.06-.76A2,2,0,0,0,112.1,215.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M112.78,217.11c-.11.17-.27.41-.49.69a3.27,3.27,0,0,1-.24.27c-.57.66-1,.94-1.29,1.3a4.7,4.7,0,0,0-.64,1.49v0c.66.72,1.34,1.5,2,2.36l.16.22c.33-.39,1-1.17,2.11-2.61a1.84,1.84,0,0,0,.39-1,3.1,3.1,0,0,0-.08-.5,9.74,9.74,0,0,0-.4-2.07h0c-.12-.34-.28-.78-.49-1.28l-.39-.9a1.76,1.76,0,0,1-.09-.2C113.14,215.61,113,216.36,112.78,217.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M68.3,208.72,62.4,211c0-.07.26-.71.56-1.56a6.14,6.14,0,0,1-2.72.8,5.37,5.37,0,0,1-1.08-.09v.12a12.9,12.9,0,0,0,0,1.88,27.85,27.85,0,0,1,9-.62,6,6,0,0,1-.13-1.38A5.18,5.18,0,0,1,68.3,208.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M91.29,218.81a2.06,2.06,0,0,0,.81-1.92,1.91,1.91,0,0,0-.66-1.13.84.84,0,0,0-.19-.15l-9.17.81A42.81,42.81,0,0,1,86.49,220c.24.21.46.42.69.64a25.06,25.06,0,0,0,3.72-1.57A2,2,0,0,0,91.29,218.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M79.18,255.79c-.43-2.72-1-5.79-1.59-9.25-.07-.38-.18-.92-.35-1.57a22.49,22.49,0,0,1-10.48,4.46,22.78,22.78,0,0,1-14.46-2.84,31.23,31.23,0,0,0-.64,4,82,82,0,0,0,0,12.93q.45,3.19.81,6.59.42,3.92.67,7.6a51.3,51.3,0,0,0-.71,6.82,50.77,50.77,0,0,0,1.13,12.74,25.43,25.43,0,0,0,2.7.12,28.45,28.45,0,0,0,3.93-.29q.53-7.38,1-14.84.7-11.3,1.27-22.4a68.56,68.56,0,0,1,6.39,11.33,69,69,0,0,1,2.68,7.05,32.22,32.22,0,0,0-.91,7.92,36.09,36.09,0,0,0,1.16,8.31c.29,1.28.68,2.82,1.23,4.55.16.51.33,1,.52,1.57a20.54,20.54,0,0,0,4-.15,20.85,20.85,0,0,0,4.29-1.05c0-.13,0-.25,0-.37-.13-13.76-.53-25.95-.53-25.95S81.16,268.15,79.18,255.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M73.49,300.57H73.2c1,3.27,1.78,5.88,2.36,7.65.25.79.49,1.52.72,2.22A32.39,32.39,0,0,1,78,318.15c.06.77.07,1.4.07,1.81l4,0,.66-.61,1.06.58H93.87c.63,0,1.08-.51.88-1l-4-1A10.56,10.56,0,0,1,86,315.06a10.9,10.9,0,0,1-2.36-3.9c-.15-.4-.27-.76-.37-1.09a19.93,19.93,0,0,1-.7-3.15c-.18-1.25-.17-1.9-.3-3.88-.11-1.57-.22-2.86-.3-3.72l-.13.05a20.85,20.85,0,0,1-4.29,1.05A20.54,20.54,0,0,1,73.49,300.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M54.72,315.22a11.71,11.71,0,0,0,1.55.32,11.43,11.43,0,0,0,3.12,0l.33-.84,1.42.72,7.65-.36a1.11,1.11,0,0,0,.21-.74,1.46,1.46,0,0,0-1.48-1.07,7.34,7.34,0,0,1-4.1-1.91,5.69,5.69,0,0,1-1-1.37c-.92-1.7-1.18-4.1-1.56-8-.1-1.11-.17-2.11-.22-3s-.06-1.42-.07-2l-.39.05a28.45,28.45,0,0,1-3.93.29,25.43,25.43,0,0,1-2.7-.12l-.79-.06c.08.63.16,1.23.24,1.81.27,1.95.56,3.56.8,4.74a52.54,52.54,0,0,1,1,6.35c.06.82.09,1.65.09,2.58S54.77,314.62,54.72,315.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M112,223.78h-.1a3.4,3.4,0,0,1-.9-.29l-.16.56a.91.91,0,0,1-1.12.62l-.14,0v2.62c1-.7,2.26-1.54,3.65-2.55-.29-.41-.6-.83-.93-1.25A2.58,2.58,0,0,1,112,223.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M54.25,240.77c.11-.3.25-.63.41-1l-.26-.05V214.06a5.77,5.77,0,0,0-1.91,5.81c.42,1.7.73,3.23,1,4.55a49.41,49.41,0,0,1,.92,8.17,45.19,45.19,0,0,1-.35,6.6q-1.4,3.39-2.77,6.77c.25.16.6.38,1,.63.05-.22.11-.44.16-.66C52.85,244.52,53.84,241.86,54.25,240.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M77.83,244.19,77,244c.12.34.21.65.29.95.25-.19.47-.38.66-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M54.66,239.8c.1-.21.19-.42.31-.64a14.75,14.75,0,0,1,1.15-1.82c.39.08,1,.2,1.85.29s1.25.08,1.53.1c1.68.1,4.9.24,13.85.29a18,18,0,0,1,1.48,1.82A16,16,0,0,1,77,244l.88.17c-.91-3.08-3.45-12-2.72-14.07.21-.59,1.38-2.39,1.42-3.91,0-1.21,3,1.22,5.45,3.2v-7.34a89.22,89.22,0,0,1-10.15,1.64,80.35,80.35,0,0,1-16.69-2.17c.78-2.62,1.57-5.23,2.35-7.85l16.7,3.42,7.79-.68v-.08a27.84,27.84,0,0,0-3.53-2.07,31.09,31.09,0,0,0-10.26-2.73,6.83,6.83,0,0,0,.43,1.36c-4.42,1.7-8.18,1.85-9.14.32a2.5,2.5,0,0,1-.31-1.06,25,25,0,0,0-3.18,1l-.08,0a5.45,5.45,0,0,0-1.51.9v25.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M54.66,239.8c.1-.21.19-.42.31-.64a14.75,14.75,0,0,1,1.15-1.82c.39.08,1,.2,1.85.29s1.25.08,1.53.1c1.68.1,4.9.24,13.85.29a18,18,0,0,1,1.48,1.82A16,16,0,0,1,77,244l.88.17c-.91-3.08-3.45-12-2.72-14.07.21-.59,1.38-2.39,1.42-3.91,0-1.21,3,1.22,5.45,3.2v-7.34a89.22,89.22,0,0,1-10.15,1.64,80.35,80.35,0,0,1-16.69-2.17c.78-2.62,1.57-5.23,2.35-7.85l16.7,3.42,7.79-.68v-.08a27.84,27.84,0,0,0-3.53-2.07,31.09,31.09,0,0,0-10.26-2.73,6.83,6.83,0,0,0,.43,1.36c-4.42,1.7-8.18,1.85-9.14.32a2.5,2.5,0,0,1-.31-1.06,25,25,0,0,0-3.18,1l-.08,0a5.45,5.45,0,0,0-1.51.9v25.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M104.34,223.13c-.68.26-1.37.51-2.08.75-3.45,1.2-6.71,2.13-9.72,2.85a43.38,43.38,0,0,0-5.36-6.09,53.16,53.16,0,0,1-5.2,1.43v7.34l.53.43q3.55,2.78,6.9,5.08a6.29,6.29,0,0,0,1.76.25c2.84.17,7.07-.55,16.85-6.9l1.54-1v-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M104.34,223.13c-.68.26-1.37.51-2.08.75-3.45,1.2-6.71,2.13-9.72,2.85a43.38,43.38,0,0,0-5.36-6.09,53.16,53.16,0,0,1-5.2,1.43v7.34l.53.43q3.55,2.78,6.9,5.08a6.29,6.29,0,0,0,1.76.25c2.84.17,7.07-.55,16.85-6.9l1.54-1v-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M82,216.35v.08h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M82,216.35v.08h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M109.7,224.68a.91.91,0,0,0,1.12-.62l.16-.56a2.08,2.08,0,0,1-.63-.47,1.32,1.32,0,0,1-.12-.2l-.28,1-4.22-1.21-1.39.53,5.22,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M109.7,224.68a.91.91,0,0,0,1.12-.62l.16-.56a2.08,2.08,0,0,1-.63-.47,1.32,1.32,0,0,1-.12-.2l-.28,1-4.22-1.21-1.39.53,5.22,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M110,223.81l.28-1a2.87,2.87,0,0,1-.12-2l-.06-.07c-1.36.6-2.81,1.2-4.32,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M110,223.81l.28-1a2.87,2.87,0,0,1-.12-2l-.06-.07c-1.36.6-2.81,1.2-4.32,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M110.11,220.88a2.87,2.87,0,0,0,.12,2,1.32,1.32,0,0,0,.12.2,2.08,2.08,0,0,0,.63.47,3.4,3.4,0,0,0,.9.29h.1a2.58,2.58,0,0,0,.3-.32l-.16-.22C111.45,222.38,110.77,221.6,110.11,220.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M110.11,220.88a2.87,2.87,0,0,0,.12,2,1.32,1.32,0,0,0,.12.2,2.08,2.08,0,0,0,.63.47,3.4,3.4,0,0,0,.9.29h.1a2.58,2.58,0,0,0,.3-.32l-.16-.22C111.45,222.38,110.77,221.6,110.11,220.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M59.17,212.17a2.5,2.5,0,0,0,.31,1.06c1,1.53,4.72,1.38,9.14-.32a6.83,6.83,0,0,1-.43-1.36A27.85,27.85,0,0,0,59.17,212.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M59.17,212.17a2.5,2.5,0,0,0,.31,1.06c1,1.53,4.72,1.38,9.14-.32a6.83,6.83,0,0,1-.43-1.36A27.85,27.85,0,0,0,59.17,212.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M86.49,220a42.81,42.81,0,0,0-4.41-3.58H82l-7.79.68-16.7-3.42c-.78,2.62-1.57,5.23-2.35,7.85a80.35,80.35,0,0,0,16.69,2.17A89.22,89.22,0,0,0,82,222.07a53.16,53.16,0,0,0,5.2-1.43C87,220.42,86.73,220.21,86.49,220Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M86.49,220a42.81,42.81,0,0,0-4.41-3.58H82l-7.79.68-16.7-3.42c-.78,2.62-1.57,5.23-2.35,7.85a80.35,80.35,0,0,0,16.69,2.17A89.22,89.22,0,0,0,82,222.07a53.16,53.16,0,0,0,5.2-1.43C87,220.42,86.73,220.21,86.49,220Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M74.83,239.84A18,18,0,0,0,73.35,238c-8.95-.05-12.17-.19-13.85-.29-.28,0-.83,0-1.53-.1s-1.46-.21-1.85-.29A14.75,14.75,0,0,0,55,239.16c-.12.22-.21.43-.31.64s-.3.67-.41,1c-.41,1.09-1.4,3.75-1.79,5.16-.05.22-.11.44-.16.66a22.78,22.78,0,0,0,14.46,2.84A22.49,22.49,0,0,0,77.24,245c-.08-.3-.17-.61-.29-.95A16,16,0,0,0,74.83,239.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M74.83,239.84A18,18,0,0,0,73.35,238c-8.95-.05-12.17-.19-13.85-.29-.28,0-.83,0-1.53-.1s-1.46-.21-1.85-.29A14.75,14.75,0,0,0,55,239.16c-.12.22-.21.43-.31.64s-.3.67-.41,1c-.41,1.09-1.4,3.75-1.79,5.16-.05.22-.11.44-.16.66a22.78,22.78,0,0,0,14.46,2.84A22.49,22.49,0,0,0,77.24,245c-.08-.3-.17-.61-.29-.95A16,16,0,0,0,74.83,239.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M68.3,208.72l.74-.29,1.65-.64.32-.13-.52-3.74-.16-1.14c.08-.3.78-.77.9-1.12s-.51-.46-1-.71-.49-.36-.58-.6A24.32,24.32,0,0,0,67.81,197a12.23,12.23,0,0,0-.34,3.07c0,.67,0,1.86-.26,1.92s-.57-1-1-1-.69,1.1-.79,1.85c-.21,1.56.26,2.17.22,3.06A4.88,4.88,0,0,1,63,209.46c-.3.85-.53,1.49-.56,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M59.16,210.17a5.37,5.37,0,0,0,1.08.09,6.14,6.14,0,0,0,2.72-.8,4.88,4.88,0,0,0,2.69-3.54c0-.89-.43-1.5-.22-3.06.1-.75.38-1.82.79-1.85s.71,1.05,1,1,.26-1.25.26-1.92a12.23,12.23,0,0,1,.34-3.07,2.57,2.57,0,0,0,0-1.27c-.48-2.27-3-3.48-3.27-3.63-3.08-1.46-6.24.22-6.76.5l-.19.11h0s0,.08,0,.12c.15.72-.22.81-.22,2.6,0,.41,0,1.12-.16,1.16s-.34-.62-.6-.6-.4.66-.47,1.11a9.28,9.28,0,0,0,.13,1.83c-.05,1.19-1.6,2.54-3.24,2.6h-.25a9.31,9.31,0,0,0,.14,1.59,8.33,8.33,0,0,0,.34,1.36,9.19,9.19,0,0,0,1.07,2.17,8.07,8.07,0,0,0,.93,1.17A7.44,7.44,0,0,0,59.16,210.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M56.34,199a9.28,9.28,0,0,1-.13-1.83c.07-.45.23-1.09.47-1.11s.43.63.6.6.16-.75.16-1.16c0-1.79.37-1.88.22-2.6,0,0,0-.08,0-.12a3.7,3.7,0,0,0-1.92-2.05,3.56,3.56,0,0,0-1.3-.33h-.28a5.5,5.5,0,0,0-2.47.64,6.11,6.11,0,0,0-2.89,6.31,5.34,5.34,0,0,0,1.36,2.76l0,.05.26.26a3.86,3.86,0,0,0,2.43,1.18h.25C54.74,201.5,56.29,200.15,56.34,199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M165.79,187l0,0,.27-.17-.53-.1.25.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M163.68,181.78h0c0,.29,0,.54,0,.71s0,.19,0,.28l5.12,1V180c-.43.38-1.1.47-2.9.71l-2.18.29v.18A5.59,5.59,0,0,1,163.68,181.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M172.31,177.19a10.22,10.22,0,0,1,.27-1l-.15,0a1.88,1.88,0,0,1-.12.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M171.47,177.1c-.8.48-1,.29-1.4.6-.79.57-.52,1.37-1.1,2.09a1.07,1.07,0,0,1-.18.19v3.75l-5.12-1c-.06.49-.14.64-.22.73a1.07,1.07,0,0,1-.34.23l2.4,3,.53.1,4.67-2.85,1.12-1.48c0-.49,0-1,0-1.55a18,18,0,0,1,.5-3.71v-.79A4.29,4.29,0,0,1,171.47,177.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M171.47,177.1c-.8.48-1,.29-1.4.6-.79.57-.52,1.37-1.1,2.09a1.07,1.07,0,0,1-.18.19v3.75l-5.12-1c-.06.49-.14.64-.22.73a1.07,1.07,0,0,1-.34.23l2.4,3,.53.1,4.67-2.85,1.12-1.48c0-.49,0-1,0-1.55a18,18,0,0,1,.5-3.71v-.79A4.29,4.29,0,0,1,171.47,177.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M119.88,194.55a.72.72,0,0,0-.11.56c.1.36.64.62,1.3.48a.91.91,0,0,0,.23.6,1,1,0,0,0,.7.32h.92c1.39,0,2.23.08,2.23.08a10.44,10.44,0,0,0,1.29-.24,2.5,2.5,0,0,0,.9-.43,3,3,0,0,0,.53-.55c.07-.09.14-.18.19-.26a3.6,3.6,0,0,0,.59.27l-.75-.64L128,194l-.42.37-3.92-2.46-1.44-.11a1.57,1.57,0,0,1-.29-.08l-1.73.39a.59.59,0,0,0-.56.35.61.61,0,0,0,.08.62.78.78,0,0,0-.43.64v0A.81.81,0,0,0,119.88,194.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M128.65,195.39l.21.18c2.25,1.91,4.21,3.46,5.85,4.69,1.33,1,2.46,1.79,3.35,2.39a15.49,15.49,0,0,0,3.63,1.84,18.87,18.87,0,0,0,3.89,1,8.35,8.35,0,0,1-.84-6.9c0-.07.09-.23.17-.41h0a40,40,0,0,0-4.85-2.37c-3.3-1.33-5.14-1.55-8.68-3.12-1.35-.6-2.42-1.17-3.07-1.53v0a1.93,1.93,0,0,1,1,1.67L128,194l-.08.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M154.61,200.45c1.26-1.33,2.31-2.46,3.24-3.45a12.47,12.47,0,0,0-.29-2.19,37.75,37.75,0,0,1-1-4.83,11,11,0,0,1,.1-3.59,3.08,3.08,0,0,1,.3-1.32l-.18,0a26.53,26.53,0,0,0-2,2.52c-2.24,3.17-3.1,5.84-5.42,6.58v5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M145.62,205.55l.24,0v-.1l-.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M149.37,203.4v1.88a8.72,8.72,0,0,0,2.35-1.8l-2.31-.44C149.4,203.16,149.39,203.29,149.37,203.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M145.86,197.86v-1.29a8.6,8.6,0,0,0-1,1.6A3.07,3.07,0,0,1,145.86,197.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M157.55,184.23l-.75.8.18,0a3,3,0,0,1,.57-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M157.55,184.23l-.75.8.18,0a3,3,0,0,1,.57-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M148.84,204.64a3.38,3.38,0,0,1-3,.86v.1a5.39,5.39,0,0,0,2.08.13,5.09,5.09,0,0,0,1.43-.45V203.4A2.63,2.63,0,0,1,148.84,204.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M148.84,204.64a3.38,3.38,0,0,1-3,.86v.1a5.39,5.39,0,0,0,2.08.13,5.09,5.09,0,0,0,1.43-.45V203.4A2.63,2.63,0,0,1,148.84,204.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M146.63,197.88c1.71.39,3,3.11,2.78,5.16l2.31.44.58-.6,2.31-2.43-5.24-1v-5.33l-.06,0a5,5,0,0,0-1,.34,6.34,6.34,0,0,0-2.47,2.07v1.29A1.93,1.93,0,0,1,146.63,197.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M146.63,197.88c1.71.39,3,3.11,2.78,5.16l2.31.44.58-.6,2.31-2.43-5.24-1v-5.33l-.06,0a5,5,0,0,0-1,.34,6.34,6.34,0,0,0-2.47,2.07v1.29A1.93,1.93,0,0,1,146.63,197.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M145.58,205.48l.28,0a3.38,3.38,0,0,0,3-.86,2.63,2.63,0,0,0,.53-1.24c0-.11,0-.24,0-.36.18-2-1.07-4.77-2.78-5.16a1.93,1.93,0,0,0-.77,0,3.07,3.07,0,0,0-1,.31c-.08.18-.14.34-.17.41A8.35,8.35,0,0,0,145.58,205.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M145.58,205.48l.28,0a3.38,3.38,0,0,0,3-.86,2.63,2.63,0,0,0,.53-1.24c0-.11,0-.24,0-.36.18-2-1.07-4.77-2.78-5.16a1.93,1.93,0,0,0-.77,0,3.07,3.07,0,0,0-1,.31c-.08.18-.14.34-.17.41A8.35,8.35,0,0,0,145.58,205.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M181,291.55a11.44,11.44,0,0,1-1.24.21c.51.13,1,.26,1.46.4C181.12,291.94,181.05,291.74,181,291.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M186.61,295.65c0-1.28-2-2.48-5.42-3.49a13.45,13.45,0,0,1,.45,1.75,13.9,13.9,0,0,1,.25,3l-4.06.11a1.81,1.81,0,0,0-1.07-.34,2,2,0,0,0-1.45.76c-1.35.22-2.83.4-4.42.51-1.41.1-2.74.13-4,.12.09-.29.17-.58.25-.87a30.11,30.11,0,0,0,8.3-5.54c-.51-.07-1-.15-1.48-.24,0-.27-.07-.52-.1-.78-3.38-.52-7.3-.93-11.58-1.2,0,.21,0,.4,0,.61a6.34,6.34,0,0,1-.87.29,13.73,13.73,0,0,1,.87,5.2l-4.05.11a1.86,1.86,0,0,0-1.07-.34,1.91,1.91,0,0,0-1.45.76c-1.35.22-2.83.4-4.43.51-1.41.1-2.74.13-4,.12l.24-.87a29.58,29.58,0,0,0,4.49-2.5,30.24,30.24,0,0,0,4.15-3.36l-.39-.16c0-.21,0-.43-.05-.64-1.53,0-3.07-.06-4.65-.06-19.61,0-35.51,2.95-35.51,6.58,0,1.22,1.8,2.37,4.93,3.35h61.16C184.81,298,186.61,296.87,186.61,295.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M186.61,295.65c0-1.28-2-2.48-5.42-3.49a13.45,13.45,0,0,1,.45,1.75,13.9,13.9,0,0,1,.25,3l-4.06.11a1.81,1.81,0,0,0-1.07-.34,2,2,0,0,0-1.45.76c-1.35.22-2.83.4-4.42.51-1.41.1-2.74.13-4,.12.09-.29.17-.58.25-.87a30.11,30.11,0,0,0,8.3-5.54c-.51-.07-1-.15-1.48-.24,0-.27-.07-.52-.1-.78-3.38-.52-7.3-.93-11.58-1.2,0,.21,0,.4,0,.61a6.34,6.34,0,0,1-.87.29,13.73,13.73,0,0,1,.87,5.2l-4.05.11a1.86,1.86,0,0,0-1.07-.34,1.91,1.91,0,0,0-1.45.76c-1.35.22-2.83.4-4.43.51-1.41.1-2.74.13-4,.12l.24-.87a29.58,29.58,0,0,0,4.49-2.5,30.24,30.24,0,0,0,4.15-3.36l-.39-.16c0-.21,0-.43-.05-.64-1.53,0-3.07-.06-4.65-.06-19.61,0-35.51,2.95-35.51,6.58,0,1.22,1.8,2.37,4.93,3.35h61.16C184.81,298,186.61,296.87,186.61,295.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M151.1,302.23c13,0,24.4-1.3,30.58-3.23H120.52C126.7,300.93,138.08,302.23,151.1,302.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M151.1,302.23c13,0,24.4-1.3,30.58-3.23H120.52C126.7,300.93,138.08,302.23,151.1,302.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M151.1,302.23c13,0,24.4-1.3,30.58-3.23H120.52C126.7,300.93,138.08,302.23,151.1,302.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M147.55,295.79l-.24.87c1.23,0,2.56,0,4-.12,1.6-.11,3.08-.29,4.43-.51a1.91,1.91,0,0,1,1.45-.76,1.86,1.86,0,0,1,1.07.34l4.05-.11a13.73,13.73,0,0,0-.87-5.2,9.39,9.39,0,0,1-5.22-.37,30.24,30.24,0,0,1-4.15,3.36A29.58,29.58,0,0,1,147.55,295.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M147.55,295.79l-.24.87c1.23,0,2.56,0,4-.12,1.6-.11,3.08-.29,4.43-.51a1.91,1.91,0,0,1,1.45-.76,1.86,1.86,0,0,1,1.07.34l4.05-.11a13.73,13.73,0,0,0-.87-5.2,9.39,9.39,0,0,1-5.22-.37,30.24,30.24,0,0,1-4.15,3.36A29.58,29.58,0,0,1,147.55,295.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M167.16,297.16c-.08.29-.16.58-.25.87,1.24,0,2.57,0,4-.12,1.59-.11,3.07-.29,4.42-.51a2,2,0,0,1,1.45-.76,1.81,1.81,0,0,1,1.07.34l4.06-.11a13.9,13.9,0,0,0-.25-3,13.45,13.45,0,0,0-.45-1.75c-.46-.14-.95-.27-1.46-.4a18.51,18.51,0,0,1-4.27-.14,30.11,30.11,0,0,1-8.3,5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M167.16,297.16c-.08.29-.16.58-.25.87,1.24,0,2.57,0,4-.12,1.59-.11,3.07-.29,4.42-.51a2,2,0,0,1,1.45-.76,1.81,1.81,0,0,1,1.07.34l4.06-.11a13.9,13.9,0,0,0-.25-3,13.45,13.45,0,0,0-.45-1.75c-.46-.14-.95-.27-1.46-.4a18.51,18.51,0,0,1-4.27-.14,30.11,30.11,0,0,1-8.3,5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M175.93,222.18l-.47,1.9-4.34,1.29-.49,1.16a1.2,1.2,0,0,1-1.5.67l.89-3.1a5.41,5.41,0,0,1,1-1.95l.55-.65a1.69,1.69,0,0,1,1.2-.59l.21-.46a34.88,34.88,0,0,0,1.54-4.2l-8.94,2.69-.69-2.05h0l-.41-1.22-1.91,2.64-5.28-3.62v-.36h0q-.37,2.91-.72,5.91l0,.24c-.13,1.16-.24,2.34-.36,3.51-.49,4.71-.9,9.55-1.2,14.54-.66,11.09-.73,21.62-.41,31.55q.33,9.94,1.15,19.05c0,.21,0,.43.05.64l.39.16a9.39,9.39,0,0,0,5.22.37,6.34,6.34,0,0,0,.87-.29c0-.21,0-.4,0-.61.14-6.49.18-12.06.16-16.84,0-.35,0-.67,0-1,0-1.45,0-2.59,0-3.36,0-2.36-.09-5.09-.18-8.13L165,234.42c.57,3.24,1,5.9,1.24,7.71.84,5.69,1,8.23,1.94,13.58.43,2.52.79,4.29,1,5.22.63,3.25,1.36,7.31,2.18,12.32.79,4.85,1.66,10.6,2.56,17.35,0,.26.07.51.1.78.47.09,1,.17,1.48.24a18.51,18.51,0,0,0,4.27.14,11.44,11.44,0,0,0,1.24-.21c.2-.05.4-.09.59-.15l-1-16.4-1.35-22.39q-.79-11-1.9-22.42c-.08-.75-.16-1.49-.23-2.24-.12-1.22-.25-2.44-.37-3.65-.1-.91-.19-1.82-.29-2.72l-.5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M168.79,215.29V204.86l-.34,1.79-2.91-.55L165,215Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M164.48,205.9,157,204.48a11.45,11.45,0,0,0,.3,2.31,10.29,10.29,0,0,1,.33,3c0,.78-.12,1.2-.21,2.33-.08.91-.1,1.67-.11,2.24l6.64.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M157.89,197l0,.05a15.1,15.1,0,0,1-.42,4l7.25,1.38.82-14.58-.41-.23c-.44.36-.88.72-1.33,1.07-.37-.82-.74-1.65-1.12-2.48l-5.06-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M172.31,184.15v1.61c.09.41.2.78.3,1.12l-.3.22v28.48l2.4.21c.28-.88.58-1.79,1-2.89l.35-.82c0-.48.11-1,.18-1.52,0-.13,0-.23.06-.35a3.07,3.07,0,0,1-1-1.49,3.49,3.49,0,0,1,.33-2.41c.61-1.34.55-4.77-2.27-13.86a3.95,3.95,0,0,1,5.6-4.76,3.5,3.5,0,0,1,1,.82l0-.21-7.33-4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M168.79,203.14V188.43l-.47,0c-.37.4-.73.8-1.1,1.19l-.68-1.26-.8,14.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M157,204.48l7.46,1.42.2-3.54L157.43,201A15.41,15.41,0,0,0,157,204.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M157,204.48l7.46,1.42.2-3.54L157.43,201A15.41,15.41,0,0,0,157,204.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M157.55,184.24l0,.94,5.06,1-1.28-2.84h0c-.41,0-.85,0-1.31-.05A3.14,3.14,0,0,0,157.55,184.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M157.55,184.24l0,.94,5.06,1-1.28-2.84h0c-.41,0-.85,0-1.31-.05A3.14,3.14,0,0,0,157.55,184.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M172.31,184.15l-.27.28c.08.48.17.92.27,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M172.31,184.15l-.27.28c.08.48.17.92.27,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M168.79,203.14l-3-.58-.2,3.54,2.91.55.34-1.79v10.43l3.52.29V187.1a6.64,6.64,0,0,1-3.52,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M168.79,203.14l-3-.58-.2,3.54,2.91.55.34-1.79v10.43l3.52.29V187.1a6.64,6.64,0,0,1-3.52,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M165.54,187.18l-.45.37.41.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M165.54,187.18l-.45.37.41.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M172.61,186.88c-.1-.34-.21-.71-.3-1.12v1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M172.61,186.88c-.1-.34-.21-.71-.3-1.12v1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M168.79,188.43v-.49l-.47.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M168.79,188.43v-.49l-.47.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M172.31,187.1v-1.34c-.1-.41-.19-.85-.27-1.33l-3.25,3.51v.49A6.64,6.64,0,0,0,172.31,187.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M172.31,187.1v-1.34c-.1-.41-.19-.85-.27-1.33l-3.25,3.51v.49A6.64,6.64,0,0,0,172.31,187.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M172.31,187.1v-1.34c-.1-.41-.19-.85-.27-1.33l-3.25,3.51v.49A6.64,6.64,0,0,0,172.31,187.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M157.58,185.18l-.6-.11a3.08,3.08,0,0,0-.3,1.32,11,11,0,0,0-.1,3.59,37.75,37.75,0,0,0,1,4.83,12.47,12.47,0,0,1,.29,2.19l0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M157.58,185.18l-.6-.11a3.08,3.08,0,0,0-.3,1.32,11,11,0,0,0-.1,3.59,37.75,37.75,0,0,0,1,4.83,12.47,12.47,0,0,1,.29,2.19l0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M157.55,184.24a3,3,0,0,0-.57.83l.6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M157.55,184.24a3,3,0,0,0-.57.83l.6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M157.55,184.24a3,3,0,0,0-.57.83l.6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M165,215l-.11,1.91.69,2.05,8.94-2.69.15-.46-2.4-.21-3.52-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M165,215l-.11,1.91.69,2.05,8.94-2.69.15-.46-2.4-.21-3.52-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M163.88,216.55l.09-1.66-6.64-.56v.36l5.28,3.62,1.91-2.64h0C164.3,216,164.09,216.26,163.88,216.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M163.88,216.55l.09-1.66-6.64-.56v.36l5.28,3.62,1.91-2.64h0C164.3,216,164.09,216.26,163.88,216.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M165.79,187h0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M165.79,187h0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M164.52,215.67l.41,1.22h0l-.41-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M164.52,215.67l.41,1.22h0l-.41-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M165.5,187.78l-.82,14.58,1.06.2.8-14.18-.13-.24-.54-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M165.5,187.78l-.82,14.58,1.06.2.8-14.18-.13-.24-.54-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M164,214.89,165,215l.5-8.88-1.06-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M164,214.89,165,215l.5-8.88-1.06-.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "165.54 206.1 165.74 202.56 164.68 202.36 164.48 205.9 165.54 206.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "165.54 206.1 165.74 202.56 164.68 202.36 164.48 205.9 165.54 206.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "165.54 206.1 165.74 202.56 164.68 202.36 164.48 205.9 165.54 206.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M165.54,187.18l0,.6.37.18.54.18-.62-1.16,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M165.54,187.18l0,.6.37.18.54.18-.62-1.16,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M165.54,187.18l0,.6.37.18.54.18-.62-1.16,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M164,214.89l-.09,1.66c.21-.29.42-.59.64-.88h0l.41,1.22L165,215Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M164,214.89l-.09,1.66c.21-.29.42-.59.64-.88h0l.41,1.22L165,215Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M164,214.89l-.09,1.66c.21-.29.42-.59.64-.88h0l.41,1.22L165,215Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M121.91,191.75a1.57,1.57,0,0,0,.29.08l1.44.11,3.92,2.46L128,194l1.3-1.16a1.93,1.93,0,0,0-1-1.67,1.74,1.74,0,0,0-.26-.15l-.92-.36a5.39,5.39,0,0,0-.68-.22,6.26,6.26,0,0,0-1.83-.19l-1.69.07-2,.09A1.37,1.37,0,0,0,121.91,191.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M180.1,208.14a8.58,8.58,0,0,0-3.3,2.4c-.28.56-.52,1.09-.72,1.54l-.35.82c-.44,1.1-.74,2-1,2.89l-.15.46a34.88,34.88,0,0,1-1.54,4.2l-.21.46a1.59,1.59,0,0,1,.65.07l.68,1.59,1.79-.38.5-.61c2.51-3,4.22-5.39,5.27-6.94a13.79,13.79,0,0,0,1.6-3.16,14.54,14.54,0,0,0,.89-3.9A8.61,8.61,0,0,0,180.1,208.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M171.61,221.5l-.55.65a5.41,5.41,0,0,0-1,1.95l-.89,3.1a1.2,1.2,0,0,0,1.5-.67l.49-1.16.33-2.22,2.69-.58-.68-1.59a1.59,1.59,0,0,0-.65-.07A1.69,1.69,0,0,0,171.61,221.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M171.83,182.45l-1.12,1.48L166,186.78l-.27.17,0,0h0l.62,1.16.13.24.68,1.26c.37-.39.73-.79,1.1-1.19l.47-.51,3.25-3.51.27-.28.32-.35h0l-.32-.63-.42-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M163.73,181.77h0l-1.07.3-.41.4-.84.82h0l1.28,2.84c.38.83.75,1.66,1.12,2.48.45-.35.89-.71,1.33-1.07l.45-.37.22-.18-.25-.32-2.4-3a1.07,1.07,0,0,0,.34-.23c.08-.09.16-.24.22-.73,0-.09,0-.17,0-.28S163.73,182.06,163.73,181.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M172.77,175.35a14.36,14.36,0,0,0,.73-4.51,7,7,0,0,0-.59-2.26,7,7,0,0,1,.59,2.26A14.36,14.36,0,0,1,172.77,175.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M159,170c0-.17.09-.34.14-.52a6.23,6.23,0,0,1,.53-1.17,6.23,6.23,0,0,0-.53,1.17C159.13,169.67,159.08,169.84,159,170Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M172.66,175.69v0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M159,170.07l-.09.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M162.75,165.29a7.84,7.84,0,0,0-1.24.82A7.84,7.84,0,0,1,162.75,165.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M170.34,176.72c-1.1-.53-.61-3.09-1.46-3.33-.37-.1-.82.29-1.19.73h-1.24a11.4,11.4,0,0,0-.49-2.67c-.46-1.49-.84-2.72-1.72-3-.66-.21-1,.31-3.63,1.45a11.23,11.23,0,0,1-1.67.62,8.69,8.69,0,0,0-.09,1.48c0,.15,0,.31,0,.45a15.81,15.81,0,0,1-.68,2.21c-.23.58-.42.94-.26,1.17s1,.12,1.32,0c.12.53.3,1.27.55,2.15.49,1.76.74,2.64,1.08,2.92s.7.32,2.81,0l2.18-.29c1.8-.24,2.47-.33,2.9-.71a1.07,1.07,0,0,0,.18-.19c.58-.72.31-1.52,1.1-2.09.44-.31.6-.12,1.4-.6a4.29,4.29,0,0,0,.84-.7,1.88,1.88,0,0,0,.12-.18.94.94,0,0,0,.13-.24C172.4,176.11,171.16,177.12,170.34,176.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M169.81,165.13a5.76,5.76,0,0,0-1-.45,7.7,7.7,0,0,0-6,.61,7.45,7.45,0,0,1,7.06-.16,7.16,7.16,0,0,1,3.1,3.45,7.91,7.91,0,0,0-.6-1.1A7,7,0,0,0,169.81,165.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M169.81,165.13a7.45,7.45,0,0,0-7.06.16,7.84,7.84,0,0,0-1.24.82s-.17.15-.36.34a8.26,8.26,0,0,0-1.44,1.87,6.23,6.23,0,0,0-.53,1.17c-.05.18-.1.35-.14.52a.13.13,0,0,1,0,.06l-.09.46h0a11.23,11.23,0,0,0,1.67-.62c2.63-1.14,3-1.66,3.63-1.45.88.27,1.26,1.5,1.72,3a11.4,11.4,0,0,1,.49,2.67h1.24c.37-.44.82-.83,1.19-.73.85.24.36,2.8,1.46,3.33.82.4,2.06-.61,2.22-.74,0,0,0-.13.1-.29v0h0v0l.05-.14s0-.09.05-.15a14.36,14.36,0,0,0,.73-4.51,7,7,0,0,0-.59-2.26A7.16,7.16,0,0,0,169.81,165.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M177.72,203.4c-.47,2.12-1,4-1.4,6.81.16.13.32.25.47.35v0c.29-.58.61-1.19,1-1.86a2.26,2.26,0,0,1-.26-1.5c.45-1.94,4.34-3.2,5.89-1.92a2.74,2.74,0,0,1,.76,2.32h0a7.77,7.77,0,0,0,.45-1.44c.48-2.32-.28-4.06-.94-6-1.2-3.57-1.16-5.47-2.76-9.74a6.24,6.24,0,0,0-1-1.84c-.17,1.32-.42,3.12-.73,5.29C178.49,198.82,178.19,201.34,177.72,203.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M178.94,187.69a3.95,3.95,0,0,0-5.6,4.76c2.82,9.09,2.88,12.52,2.27,13.86a3.49,3.49,0,0,0-.33,2.41,3.07,3.07,0,0,0,1,1.49c.41-2.85.93-4.69,1.4-6.81s.77-4.58,1.48-9.6c.31-2.17.56-4,.73-5.29A3.5,3.5,0,0,0,178.94,187.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M178.94,187.69a3.95,3.95,0,0,0-5.6,4.76c2.82,9.09,2.88,12.52,2.27,13.86a3.49,3.49,0,0,0-.33,2.41,3.07,3.07,0,0,0,1,1.49c.41-2.85.93-4.69,1.4-6.81s.77-4.58,1.48-9.6c.31-2.17.56-4,.73-5.29A3.5,3.5,0,0,0,178.94,187.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M183.43,205.26c-1.55-1.28-5.44,0-5.89,1.92a2.26,2.26,0,0,0,.26,1.5c-.39.67-.71,1.28-1,1.86a8.41,8.41,0,0,1,7.39-3A2.74,2.74,0,0,0,183.43,205.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M183.43,205.26c-1.55-1.28-5.44,0-5.89,1.92a2.26,2.26,0,0,0,.26,1.5c-.39.67-.71,1.28-1,1.86a8.41,8.41,0,0,1,7.39-3A2.74,2.74,0,0,0,183.43,205.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "171.45 223.15 171.12 225.37 175.47 224.08 175.93 222.19 175.93 222.19 174.14 222.57 171.45 223.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M428.69,502.09c.12.08.2.16.21.25a.29.29,0,0,1,0,.16c.06.41-.49.5-.93.56a3.19,3.19,0,0,0-.42.09,4.52,4.52,0,0,1-.75.14,11.56,11.56,0,0,1-2.68-.11,12.6,12.6,0,0,0-1.26-.09c-.21,0-.43,0-.66,0-1.14.12-2.41.47-3.24.13a1.11,1.11,0,0,1-.31-.15,1.56,1.56,0,0,1-.62-.78h0v0a4.41,4.41,0,0,1-.09-1.24,2.44,2.44,0,0,0,0-.27,1.59,1.59,0,0,1,0-.43c0-.34.1-.71.11-1.13a21.27,21.27,0,0,0-.59-4.24c-4.27-.32-8.93-.49-13.82-.49h-2.22c-.11.64-.22,1.3-.32,2-.12.87-.26,1.87-.35,2.77l.57,0h1a6.6,6.6,0,0,1,.95.11s-.07,0,0,0a4.81,4.81,0,0,1,1.29.39l0,0c.05,0,.09.07.1.11s0,.09,0,.12a.28.28,0,0,1-.07.24l-.09.1h0l0,0a2.66,2.66,0,0,1-.51.42,6,6,0,0,1-1.32.65c-.44.17-.88.33-1.28.51l-.09,0a4.36,4.36,0,0,0-.48.29,2.67,2.67,0,0,1-.77.4l-.19.07-.6.14a1.39,1.39,0,0,1-.95-.07,2.73,2.73,0,0,1-.31-.14,1.64,1.64,0,0,1-.28-.24,1.5,1.5,0,0,1-.48-.85,1.53,1.53,0,0,1,0-.3,2.14,2.14,0,0,1,0-.34c0-.15.05-.32.07-.5a8.21,8.21,0,0,1,.06-.84h0c0-.54,0-1.16,0-1.81,0-1.13-.07-2.17-.17-3.26-17.54.56-30.89,3.39-30.89,6.8,0,3.82,16.67,6.91,37.24,6.91s37.25-3.09,37.25-6.91c0-2.6-7.77-4.86-19.24-6a8.21,8.21,0,0,0,1.25,4.35C424.62,501.73,427.69,500.89,428.69,502.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M428.69,502.09c.12.08.2.16.21.25a.29.29,0,0,1,0,.16c.06.41-.49.5-.93.56a3.19,3.19,0,0,0-.42.09,4.52,4.52,0,0,1-.75.14,11.56,11.56,0,0,1-2.68-.11,12.6,12.6,0,0,0-1.26-.09c-.21,0-.43,0-.66,0-1.14.12-2.41.47-3.24.13a1.11,1.11,0,0,1-.31-.15,1.56,1.56,0,0,1-.62-.78h0v0a4.41,4.41,0,0,1-.09-1.24,2.44,2.44,0,0,0,0-.27,1.59,1.59,0,0,1,0-.43c0-.34.1-.71.11-1.13a21.27,21.27,0,0,0-.59-4.24c-4.27-.32-8.93-.49-13.82-.49h-2.22c-.11.64-.22,1.3-.32,2-.12.87-.26,1.87-.35,2.77l.57,0h1a6.6,6.6,0,0,1,.95.11s-.07,0,0,0a4.81,4.81,0,0,1,1.29.39l0,0c.05,0,.09.07.1.11s0,.09,0,.12a.28.28,0,0,1-.07.24l-.09.1h0l0,0a2.66,2.66,0,0,1-.51.42,6,6,0,0,1-1.32.65c-.44.17-.88.33-1.28.51l-.09,0a4.36,4.36,0,0,0-.48.29,2.67,2.67,0,0,1-.77.4l-.19.07-.6.14a1.39,1.39,0,0,1-.95-.07,2.73,2.73,0,0,1-.31-.14,1.64,1.64,0,0,1-.28-.24,1.5,1.5,0,0,1-.48-.85,1.53,1.53,0,0,1,0-.3,2.14,2.14,0,0,1,0-.34c0-.15.05-.32.07-.5a8.21,8.21,0,0,1,.06-.84h0c0-.54,0-1.16,0-1.81,0-1.13-.07-2.17-.17-3.26-17.54.56-30.89,3.39-30.89,6.8,0,3.82,16.67,6.91,37.24,6.91s37.25-3.09,37.25-6.91c0-2.6-7.77-4.86-19.24-6a8.21,8.21,0,0,0,1.25,4.35C424.62,501.73,427.69,500.89,428.69,502.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M428.69,502.09c.12.08.2.16.21.25a.29.29,0,0,1,0,.16c.06.41-.49.5-.93.56a3.19,3.19,0,0,0-.42.09,4.52,4.52,0,0,1-.75.14,11.56,11.56,0,0,1-2.68-.11,12.6,12.6,0,0,0-1.26-.09c-.21,0-.43,0-.66,0-1.14.12-2.41.47-3.24.13a1.11,1.11,0,0,1-.31-.15,1.56,1.56,0,0,1-.62-.78h0v0a4.41,4.41,0,0,1-.09-1.24,2.44,2.44,0,0,0,0-.27,1.59,1.59,0,0,1,0-.43c0-.34.1-.71.11-1.13a21.27,21.27,0,0,0-.59-4.24c-4.27-.32-8.93-.49-13.82-.49h-2.22c-.11.64-.22,1.3-.32,2-.12.87-.26,1.87-.35,2.77l.57,0h1a6.6,6.6,0,0,1,.95.11s-.07,0,0,0a4.81,4.81,0,0,1,1.29.39l0,0c.05,0,.09.07.1.11s0,.09,0,.12a.28.28,0,0,1-.07.24l-.09.1h0l0,0a2.66,2.66,0,0,1-.51.42,6,6,0,0,1-1.32.65c-.44.17-.88.33-1.28.51l-.09,0a4.36,4.36,0,0,0-.48.29,2.67,2.67,0,0,1-.77.4l-.19.07-.6.14a1.39,1.39,0,0,1-.95-.07,2.73,2.73,0,0,1-.31-.14,1.64,1.64,0,0,1-.28-.24,1.5,1.5,0,0,1-.48-.85,1.53,1.53,0,0,1,0-.3,2.14,2.14,0,0,1,0-.34c0-.15.05-.32.07-.5a8.21,8.21,0,0,1,.06-.84h0c0-.54,0-1.16,0-1.81,0-1.13-.07-2.17-.17-3.26-17.54.56-30.89,3.39-30.89,6.8,0,3.82,16.67,6.91,37.24,6.91s37.25-3.09,37.25-6.91c0-2.6-7.77-4.86-19.24-6a8.21,8.21,0,0,0,1.25,4.35C424.62,501.73,427.69,500.89,428.69,502.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M379.8,440h0c0-.29.09-.58.14-.87,0-.1.06-.29.08-.4l3-1.76.06.14c0-.19,0-.37.05-.55.05-.58.09-1.08.12-1.38.16-1.47.33-2.88.5-4.28.42-3.46.83-6.76.91-10.23,0-1.12-.06-1.85,0-2.84a4.61,4.61,0,0,1,.25-1.26,10,10,0,0,1,1.56-3c.65-.88,1.27-1.76,1.88-2.65-.85-.58-1.46-.93-2.37-1.58s-2.2-1.48-3.16-2.18a43.82,43.82,0,0,0-2.81,8.32c-.08.34-.23.61-.29,1a6.4,6.4,0,0,0-.09,1c0,4.19.05,8.42.09,12.65,0,1.92,0,3.84,0,5.76C379.77,437.28,379.78,438.65,379.8,440Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M389.81,408.76l-1.4,2.08,1.41-2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M386,401.59h0c-.14.21-.27.42-.4.63l-.08.13a42.54,42.54,0,0,0-2.63,4.75A45.25,45.25,0,0,1,386,401.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M388.41,410.84l-.06.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M388.41,410.84l-.06.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M382.84,407.1l0,.06h0A.14.14,0,0,1,382.84,407.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M382.84,407.1l0,.06h0A.14.14,0,0,1,382.84,407.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M388.35,410.92l.06-.08,1.4-2.08a42.42,42.42,0,0,0-3.86-7.17,45.25,45.25,0,0,0-3.11,5.51.14.14,0,0,0,0,.06h0c1,.7,2.25,1.53,3.16,2.18S387.5,410.34,388.35,410.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M388.35,410.92l.06-.08,1.4-2.08a42.42,42.42,0,0,0-3.86-7.17,45.25,45.25,0,0,0-3.11,5.51.14.14,0,0,0,0,.06h0c1,.7,2.25,1.53,3.16,2.18S387.5,410.34,388.35,410.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M398.89,378.12a.37.37,0,0,0,0-.09,20.78,20.78,0,0,1,3.45,5,1.15,1.15,0,0,0,.62.59c.29.14,1.11.23,1,.68s-.71.71-.85,1.16c.3,1.6.54,3.23.9,4.8-1.12.48-.76.35-2.22,1l-1,.44a5.86,5.86,0,0,0-.14,2.15,3.9,3.9,0,0,0,.43,1.38c1.62.06,3.63,0,4.42-.6,1.16-.85,2.9-4.34,2.9-4.54,0-3.6-1.25-4.48-3.36-6.32-.64-1.7-1.1-3.44-2.89-4.54-1.57-1-4.46-2.79-6.59-1.59A8.17,8.17,0,0,1,398.89,378.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M404.65,500.29a.28.28,0,0,0,.07-.24A.34.34,0,0,1,404.65,500.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M397.42,499.66c.21,0,.5.15.7.18a5.11,5.11,0,0,0,.53,0,4.13,4.13,0,0,1,.77.07c.52.19.6.62,1.1.73a1.13,1.13,0,0,0,.58-.18c.28-.14,1-.35.95-.71s-.61-.41-.86-.49h.13l-.57,0c.09-.9.23-1.9.35-2.77.1-.7.21-1.36.32-2,.22-1.29.45-2.54.69-4,0-.07,0-.13,0-.2a50.63,50.63,0,0,0,.57-6.19c0-.37,0-.75,0-1.11l-.44,0c-2.16.09-4.31.1-6.46.17l0-.39h0c.09.67.22,1.69.37,2.79.25,1.85.52,3.89.63,4.7.06.48.12.92.17,1.36.15,1.08.26,2,.34,2.95.1,1.09.16,2.13.17,3.26C397.46,498.5,397.45,499.12,397.42,499.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M404.59,499.8l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M397.76,502.49a1.91,1.91,0,0,1-.48-.85A1.5,1.5,0,0,0,397.76,502.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M400.86,502.33a3.29,3.29,0,0,1-.77.4A2.67,2.67,0,0,0,400.86,502.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M402.71,501.49c-.43.16-.87.32-1.28.51C401.83,501.82,402.27,501.66,402.71,501.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M404.54,500.42l0,0a2.81,2.81,0,0,1-.53.45A2.66,2.66,0,0,0,404.54,500.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M397.35,500.5c0,.18,0,.35-.07.5a2.14,2.14,0,0,0,0,.34,1.09,1.09,0,0,1,0-.25A2.12,2.12,0,0,0,397.35,500.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M398.35,502.87a1.39,1.39,0,0,0,.95.07A1.59,1.59,0,0,1,398.35,502.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M421.35,484.05l-.06-.64c0,.21,0,.42,0,.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M395.76,471.62a58.7,58.7,0,0,0,.06,11.17l0,.39c2.15-.07,4.3-.08,6.46-.17h.44a46.5,46.5,0,0,0,0-7.47,35.47,35.47,0,0,1-.22-5.2,27.63,27.63,0,0,1,.9-4.35,11.31,11.31,0,0,0,.48-2.5,37.55,37.55,0,0,1-8.67-.18c.28,1.59.62,3.15,1,4.76C396.07,469.2,395.86,470.49,395.76,471.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M420.42,469c-.62-3.53-1.19-6.5-1.82-10.15a37.73,37.73,0,0,1-8.12,3.4c.29.93.57,1.77.81,2.35.42,1,1.44,3.17,2.06,4.48a12.05,12.05,0,0,1,.88,3,40.62,40.62,0,0,1,.17,7.13c0,.59,0,1.44.11,2.33.09,1.15.22,2.37.38,3.23h0c-.08-.58-.16-1.17-.24-1.81,2.16-.4,4.28-1.08,6.45-1.38,0-.49-.09-1-.12-1.47-.11-1.35-.2-2.7-.28-4.05C420.6,473.72,420.5,471.33,420.42,469Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M417.26,401.74l.11,0c6.28-2.41,10.82-6,16.43-9.36,3-3.67,5.73-8.41,8.57-11.9l.24-.29c1.44-1.77,2.4-2.89,3.6-4.41l.64-.81a2.12,2.12,0,0,1-.57.09c-.71,0-2.41,0-2.92-.85-.27-.43.13-.72.38-1.14h0a26.17,26.17,0,0,1-3.31,2.87l-.11.08c-3.08,2.22-5.37,3.58-7.88,6.58a27.72,27.72,0,0,0-4.33,6.37c-1.62.43-3.76,1.14-5.2,1.68-2.72,1-4.85,2.39-7.42,3.38l-.65.23c.87,2.45,1.78,5,2.6,7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M410.69,420.64l.15.74H411C410.87,421.13,410.78,420.88,410.69,420.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M412.19,404.56a6.48,6.48,0,0,0-1.51,1.64A9.87,9.87,0,0,1,412.19,404.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M409.57,408.23c-.31.35-.56.52-.42,2.41a12.72,12.72,0,0,1,.24-1.76A6.16,6.16,0,0,1,409.57,408.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M400.76,391.72l-.71.31a6.44,6.44,0,0,1-1,4.05l2.48-.09a7.11,7.11,0,0,1-.47-.74,3.9,3.9,0,0,1-.43-1.38A5.86,5.86,0,0,1,400.76,391.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M401.77,391.28c1.46-.63,1.1-.5,2.22-1-.36-1.57-.6-3.2-.9-4.8.14-.45.74-.72.85-1.16s-.71-.54-1-.68a1.15,1.15,0,0,1-.62-.59,20.78,20.78,0,0,0-3.45-5,.37.37,0,0,1,0,.09l.06,0a8.42,8.42,0,0,1,.39,2.09,11.89,11.89,0,0,1-.35,2.89c-.47,2.82.69,3.9.92,6.82,0,.61.12,1.34.14,2.09l.71-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M449.27,372.76a3.76,3.76,0,0,0,.59-2,2.61,2.61,0,0,0-.48-1.2c-.19-.42-.46-.37-.49-.67-.1-1,1.22-1.95,1.52-2.86,0-.13.48-.75.07-.86s-1.54,1.31-1.92,1.69c-.59.6-1.54,1.32-2.35,2a6.88,6.88,0,0,0-1.25,1.35c-.68,1.08-.68,1.8-1.2,2.71l0,0c-.25.42-.65.71-.38,1.14.51.84,2.21.84,2.92.85a2.12,2.12,0,0,0,.57-.09,5.42,5.42,0,0,0,1.08-.53A4.27,4.27,0,0,0,449.27,372.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M406.13,458.15a43.41,43.41,0,0,1-14.91-.1c.1,1.71.22,3.29.37,4.59,1.23.28,2.44.49,3.64.66a37.55,37.55,0,0,0,8.67.18,42.89,42.89,0,0,0,4.25-.65c.79-.16,1.56-.36,2.33-.58a37.73,37.73,0,0,0,8.12-3.4c.93-.52,1.84-1.06,2.74-1.64-.36-1.12-.74-2.26-1.11-3.41l-.21-.61A52,52,0,0,1,406.13,458.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M389.81,408.76v0c.38.91.74,1.82,1.07,2.74,1.08,7.66.79,13.73.44,20.83-.09,1.84-.18,3.75-.25,5.77,0,1.09-.08,2.21-.11,3.37,0,1.61-.05,4,0,6.67,0,.28,0,.56,0,.85a61.54,61.54,0,0,0,26.26-4.49c-.14-.46-.29-.92-.43-1.38-.66-2.09-1.31-4.21-1.94-6.33-1.55-5.21-2.95-10.44-4-15.43l-.15-.74c-.65-3.16-1.16-6.22-1.46-9.11,0-.34-.06-.63-.08-.89-.14-1.89.11-2.06.42-2.41a2.16,2.16,0,0,0,.38-.62c.08-.2.17-.38.26-.57a6.76,6.76,0,0,1,.47-.84,6.48,6.48,0,0,1,1.51-1.64c1.49-1.16,3.3-1.64,5.07-2.82l.18-.11c-.82-2.41-1.73-5-2.6-7.41l-.06-.16a45.94,45.94,0,0,1-9,1.77c-1.35.09-2.77.12-4.22.16l-2.48.09a4.33,4.33,0,0,1-.43.53,7.06,7.06,0,0,1-7.83,1.85,4.09,4.09,0,0,1-.71-.37,14.55,14.55,0,0,0-4.12,3.5h0A42.42,42.42,0,0,1,389.81,408.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M406.17,451.43a51.85,51.85,0,0,1-15.17.5c0,1,0,1.94.08,2.9a48.26,48.26,0,0,0,14.35-.11,66.55,66.55,0,0,0,13.69-4.29c-.31-.94-.61-1.89-.92-2.84A57.9,57.9,0,0,1,406.17,451.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M405.43,454.72a48.26,48.26,0,0,1-14.35.11H391c.05,1.07.11,2.14.19,3.22h0a43.41,43.41,0,0,0,14.91.1,52,52,0,0,0,13.89-5l0,0c-.3-.93-.58-1.85-.87-2.77l-.07,0A66.55,66.55,0,0,1,405.43,454.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M405.45,448a67.89,67.89,0,0,1-14.5,1h-.07c0,1,0,1.93,0,2.91H391a51.85,51.85,0,0,0,15.17-.5,57.9,57.9,0,0,0,12-3.84l.1,0c-.31-1-.63-2.06-.94-3.09l-.15.06A67.5,67.5,0,0,1,405.45,448Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M424.12,503.18a11.56,11.56,0,0,0,2.68.11A12.7,12.7,0,0,1,424.12,503.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M418,502.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M418,502.29a4.89,4.89,0,0,1-.09-1.24A4.41,4.41,0,0,0,418,502.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M419,503.26c.83.34,2.1,0,3.24-.13C421.05,503.25,419.79,503.59,419,503.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M428,503.06c.44-.06,1-.15.93-.56C428.84,502.84,428.36,503,428,503.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M414.93,484.78c.14,1,.3,2,.5,2.91a35.73,35.73,0,0,0,1.17,4.19,30.08,30.08,0,0,1,.86,3.1,21.27,21.27,0,0,1,.59,4.24c0,.42-.08.79-.11,1.13a9.13,9.13,0,0,0,.11-1s.12,0,.19,0a4.62,4.62,0,0,1,2,.88,3.7,3.7,0,0,0,2,.94,24.55,24.55,0,0,0,2.84,0,14.8,14.8,0,0,1,3.6.87c-1-1.2-4.07-.36-5.79-2.39a8.21,8.21,0,0,1-1.25-4.35,30.85,30.85,0,0,1,0-4.3c.05-.73,0-2.66-.16-4.65,0-.8-.09-1.61-.14-2.35,0-.22,0-.43,0-.64,0-.73-.08-1.37-.1-1.83h-.05c-2.17.3-4.29,1-6.45,1.38C414.77,483.61,414.85,484.2,414.93,484.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M417.93,501.05a4.89,4.89,0,0,0,.09,1.24v0h0a1.56,1.56,0,0,0,.62.78,1.11,1.11,0,0,0,.31.15c.83.33,2.09,0,3.24-.13.23,0,.45,0,.66,0a12.6,12.6,0,0,1,1.26.09,12.7,12.7,0,0,0,2.68.11,4.52,4.52,0,0,0,.75-.14,3.19,3.19,0,0,1,.42-.09c.39-.09.87-.22.93-.56a.29.29,0,0,0,0-.16c0-.09-.09-.17-.21-.25a14.8,14.8,0,0,0-3.6-.87,24.55,24.55,0,0,1-2.84,0,3.7,3.7,0,0,1-2-.94,4.62,4.62,0,0,0-2-.88c-.07,0-.19-.07-.19,0a9.13,9.13,0,0,1-.11,1,1.59,1.59,0,0,0,0,.43A2.44,2.44,0,0,1,417.93,501.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M402.05,499.79c0,.36-.67.57-.95.71a1.13,1.13,0,0,1-.58.18c-.5-.11-.58-.54-1.1-.73a4.13,4.13,0,0,0-.77-.07,5.11,5.11,0,0,1-.53,0c-.2,0-.49-.14-.7-.18h0a8.21,8.21,0,0,0-.06.84,2.12,2.12,0,0,1-.06.59,1.09,1.09,0,0,0,0,.25,1.53,1.53,0,0,0,0,.3,1.91,1.91,0,0,0,.48.85,1.64,1.64,0,0,0,.28.24,2.73,2.73,0,0,0,.31.14,1.59,1.59,0,0,0,.95.07l.6-.14.19-.07a3.29,3.29,0,0,0,.77-.4,4.36,4.36,0,0,1,.48-.29l.09,0c.41-.19.85-.35,1.28-.51a6,6,0,0,0,1.32-.65,2.81,2.81,0,0,0,.53-.45h0l.09-.1a.34.34,0,0,0,.07-.24s0-.07,0-.12,0-.07-.1-.11l0,0a4.81,4.81,0,0,0-1.29-.39c-.1,0,0,0,0,0a6.6,6.6,0,0,0-.95-.11h-1.13C401.44,499.38,402,499.42,402.05,499.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M398.61,396.61a4.33,4.33,0,0,0,.43-.53,6.44,6.44,0,0,0,1-4.05c0-.75-.1-1.48-.14-2.09-.23-2.92-1.39-4-.92-6.82a11.89,11.89,0,0,0,.35-2.89,8.42,8.42,0,0,0-.39-2.09l-.06,0a8.17,8.17,0,0,0-3.36-.46,12.83,12.83,0,0,0-4.7,1.38c-1.87.93-3.47,4.44-3.69,5.41-.75,3.3-.31,4.4.45,7.09a6.16,6.16,0,0,0-.3,3.13c.13,1.37,1.69,2.74,2.78,3.42a4.09,4.09,0,0,0,.71.37A7.06,7.06,0,0,0,398.61,396.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M382.1,449.13a1.4,1.4,0,0,0,1.16-1.32c.05-.35.1-.72.14-1.11.12-1.06.23-2.22.36-3.22.15.74.31,1.49.46,2.24.21,0,.35.34.61.09s.22-1,.19-1.43a18.81,18.81,0,0,0-1.25-5.76c-.16-.4-.44-1-.65-1.49l-.06-.14-3,1.76c0,.11-.06.3-.08.4-.05.29-.1.58-.14.87a22,22,0,0,0-.25,5.94,16,16,0,0,0,.28,1.78C380.31,448.29,381.41,449.26,382.1,449.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M382.1,449.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M591.08,355.36l7,1.37c1.3.26,2.36-.86,2.36-2.49v-8.76a3.44,3.44,0,0,0-2.36-3.42l-7-1.37c-1.31-.26-2.37.86-2.37,2.49v8.76A3.44,3.44,0,0,0,591.08,355.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M591.08,355.36l7,1.37c1.3.26,2.36-.86,2.36-2.49v-8.76a3.44,3.44,0,0,0-2.36-3.42l-7-1.37c-1.31-.26-2.37.86-2.37,2.49v8.76A3.44,3.44,0,0,0,591.08,355.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M591.08,355.36l7,1.37c1.3.26,2.36-.86,2.36-2.49v-8.76a3.44,3.44,0,0,0-2.36-3.42l-7-1.37c-1.31-.26-2.37.86-2.37,2.49v8.76A3.44,3.44,0,0,0,591.08,355.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M598.1,403.09l-7-1.37c-1.31-.26-2.37.86-2.37,2.49V413a3.43,3.43,0,0,0,2.37,3.42l7,1.37c1.3.26,2.36-.86,2.36-2.49v-8.76A3.45,3.45,0,0,0,598.1,403.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M598.1,403.09l-7-1.37c-1.31-.26-2.37.86-2.37,2.49V413a3.43,3.43,0,0,0,2.37,3.42l7,1.37c1.3.26,2.36-.86,2.36-2.49v-8.76A3.45,3.45,0,0,0,598.1,403.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "675.23 486.22 437.68 531.23 408.3 536.8 368.76 544.29 306.66 532.52 62.29 486.22 62.29 563.24 62.29 600 675.63 600 675.63 486.22 675.23 486.22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.e74de3ec0611913bda20171ee936a782.svg";
export { ForwardRef as ReactComponent };